<template>
  <div>
    <div class="video_channel">
      <div class="vc_concent">
        <div class="vc_item" v-for="item in channelList" :key="item.at_id">
          <a
            :href="
              item.at_name == '推荐'
                ? '/marvel-list?id=' + item.at_id
                : '/list-page?id=' + item.at_id
            "
            target="_blank"
          >
            {{ item.at_name }}
          </a>
        </div>
      </div>
    </div>
    <div class="video_details">
      <div v-show="playerOptions.sources[0].src" class="v_player">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
        ></video-player>
      </div>
      <div class="video_album" v-show="isAlbumDisplay">
        <div class="album_bar">
          <span class="album_item">选集</span>
          <span class="cancel" @click="disPlayAlbum">取消</span>
        </div>
        <ul class="album_num">
          <li
            v-for="item in albumList"
            :key="item.column"
            :class="item.column == currentNum ? 'active' : ''"
            @click="changeAlum(item.column)"
          >
            <!--            <a :href="'/play-page?classify=3&id='+item">{{ index + 1 }}</a>-->
            <p class="item_idx">{{ item.column }}</p>
          </li>
        </ul>
      </div>

      <div class="vd_right">
        <!--        <div v-if="!isAlbum" class="vd_header">-->
        <!--          <div class="vdh_author">-->
        <!--            <img :src="image"/>-->
        <!--          </div>-->
        <!--          <div class="vdh_title">-->
        <!--            <p>-->
        <!--              {{ name }}-->
        <!--            </p>-->
        <!--            <el-button type="text" @click="dialogVisible = true">关注</el-button>-->
        <!--            &lt;!&ndash;            <button>关注</button>&ndash;&gt;-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="vd_title">
          <p>
            {{ title }}
            <!--            <button v-if="isOriginal">原创</button>-->
          </p>
        </div>
        <div class="vd_text">{{ description }}</div>
        <!--        <div class="vd_play_comments">-->
        <!--          <div class="vdc_play">{{ hitCount }}次播放</div>-->
        <!--          <div class="vdc_comments">{{ reviewCount ? reviewCount : 0 }}条评论</div>-->
        <!--        </div>-->
        <!--        <div class="vd_release">发布于{{ publishDate }}</div>-->
        <div class="vd_copyright">版权归原作者所有，如有侵权，请联系我们</div>
        <div class="share_info">
          <div class="share_sub">分享到：</div>
          <div
            class="social-share"
            data-sites="wechat, weibo, qq, qzone, douban"
          ></div>
        </div>
      </div>
      <!--      <div class="recommend">-->
      <!--        <div class="title">相关推荐</div>-->
      <!--        <ul class="content">-->
      <!--          <li v-for="item in recommendList" :key="item.id">-->
      <!--            <a :href="'/play-page?id=' + item.id">-->
      <!--              <div class="cul_img">-->
      <!--                <img :src="item.img_url" alt=""/>-->
      <!--                <div class="time">-->
      <!--                  <span class="v_pub">{{-->
      <!--                      item.publish_date ? item.publish_date.substr(5, 5) : ''-->
      <!--                    }}</span>-->
      <!--                  <span class="v_dur"> {{ item.video_duration }}</span>-->

      <!--                  &lt;!&ndash;                <div class="fr">{{item.video_duration}}</div>&ndash;&gt;-->
      <!--                </div>-->
      <!--              </div>-->
      <!--              <div class="cul_title1">-->
      <!--                {{ item.title }}-->
      <!--              </div>-->
      <!--              <div v-show="item.article_source" class="cul_title2">{{ item.article_source }}</div>-->
      <!--            </a>-->
      <!--          </li>-->
      <!--        </ul>-->
      <!--      </div>-->
      <!--      <div class="vd_cmt">-->
      <!--        <div class="comment">-->
      <!--          <div v-if="commentList.length>0" class="title">评论</div>-->
      <!--          <li class="item" v-for="item in commentList" :key="item.id">-->
      <!--            <div class="item_label">-->
      <!--              <div class="portrait">-->
      <!--                <div class="p_img">-->
      <!--                  <img :src="item.member.avatar" alt=""/>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--              <div class="commentator">{{ item.member.nickname }}</div>-->
      <!--              <div class="grade">-->
      <!--                {{ item.member.from_grade ? item.member.from_grade : "游客" }}-->
      <!--              </div>-->
      <!--            </div>-->
      <!--            <div class="item_text">{{ item.content }}</div>-->
      <!--            <div class="item_date">{{ item.push_time }}</div>-->
      <!--          </li>-->
      <!--        </div>-->
      <!--        <div class="act_footer">-->
      <!--          请-->
      <!--          &lt;!&ndash;          <button class="btn" data-toggle="modal" data-target="#myModal">&ndash;&gt;-->
      <!--          &lt;!&ndash;            打开&ndash;&gt;-->
      <!--          &lt;!&ndash;          </button>&ndash;&gt;-->
      <!--          <el-button type="text" @click="dialogVisible = true">打开</el-button>-->
      <!--          科普中国APP发表评论或查看更多评论-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <download-dialog :visible.sync="dialogVisible"></download-dialog>
  </div>
</template>
<script>
import downloadDialog from "./component/DownloadDialog.vue";
import { getChannelList } from "@/api";
import videojs from "video.js";

export default {
  components: { downloadDialog },
  data() {
    return {
      dialogVisible: false,
      isAlbumDisplay: true,
      channelList: [],
      isAlbum: false,
      currentNum: "1",
      // isOriginal: false,
      title: "",
      description: "",
      albumList: [],
      playerOptions: {
        playbackRates: [0.5, 1, 1.5, 2],
        autoplay: true,
        poster: "",
        // fluid: true,
        sources: [
          {
            type: "video/mp4",
            src: "",
          },
        ],
        height: 510,
        controlBar: {
          children: [
            "playToggle",
            "volumePanel",
            "currentTimeDisplay",
            "progressControl",
            "timeDivider",
            "durationDisplay",
            "fullscreenToggle",
            "customButton",
            "playbackRateMenuButton",
            "pictureInPictureToggle",
          ],
        },
      },
      config: {
        sites: ["wechat", "weibo", "qq", "qzone", "douban"],
      },
    };
  },
  methods: {
    disPlayAlbum: function () {
      this.isAlbumDisplay = !this.isAlbumDisplay;
    },

    async initPlayPage() {
      this.initAlbumButton();
      let id = this.$route.query.id - 1;

      this.playerOptions.sources[0].src = mock[id].list[0].url;
      // this.playerOptions.sources.poster = mock[id].list[currentIdx].image;
      this.title = mock[id].list[0].title;
      this.description = mock[id].desc;
      this.albumList = mock[id].list;
    },

    async initChannelList() {
      try {
        let { data } = await getChannelList();
        this.channelList = data;
      } catch (e) {
        console.log(e);
      }
    },

    // async getCommentList() {
    //   let id = this.$route.query.id;
    //   let type = 1;
    //   if (!isNaN(parseInt(id))) {
    //     type = 3;
    //   }
    //   try {
    //     let {data} = await getCommentList({ar_id: id, tar_type: type});
    //     this.commentList = data.list.slice(0, 3);
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },

    initAlbumButton() {
      var VjsButton = videojs.getComponent("button");
      var customButton = videojs.extend(VjsButton, {
        constructor: function (player, options) {
          VjsButton.call(this, player, options);
          this.controlText("视频选集");
        },
        handleClick: () => {
          this.isAlbumDisplay = !this.isAlbumDisplay;
        },
        buildCSSClass: function () {
          return "vjs-album-control";
        },
      });
      videojs.registerComponent("customButton", customButton);
    },

    changeAlum(albumIdx) {
      this.currentNum = albumIdx;
      let id = this.$route.query.id - 1;
      this.playerOptions.sources[0].src = mock[id].list[albumIdx - 1].url;
      // this.playerOptions.sources.poster = mock[id].list[currentIdx].image;
      this.title = mock[id].list[albumIdx - 1].title;
      this.description = mock[id].desc;
    },

    // jumpDetailPage(id) {
    //   this.$router.push({name: "PlayPage", query: {id: id}});
    // },
  },
  created() {
    this.initPlayPage();
    this.initChannelList();
    // this.getCommentList();
  },
  mounted() {
    // eslint-disable-next-line no-undef
    socialShare(".social-share, .share-component");
  },
};
const mock = [
  {
    title: "蓝迪安全教育",
    desc: "蓝迪安全教育，是关于安全、习惯方面的培养、认知内容，以实际拍摄小朋友的行为规范，带给电视机旁的宝宝们正确的示范，进而模仿，形成自己的良好的行为习惯，和安全意识",
    list: [
      {
        column: "1",
        title: "蓝迪安全教育-01集：怎么睡觉最舒服",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499393453281_39_1561.mp4",
      },
      {
        column: "2",
        title: "蓝迪安全教育-02集：怎么等车最安全",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499393425930_39_1796.mp4",
      },
      {
        column: "3",
        title: "蓝迪安全教育-03集：远离烟花爆竹",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499393400991_39_1710.mp4",
      },
      {
        column: "4",
        title: "蓝迪安全教育-04集：原地等爷爷",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499393330571_39_1716.mp4",
      },
      {
        column: "5",
        title: "蓝迪安全教育-05集：浴室里的安全",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499393289662_39_1457.mp4",
      },
      {
        column: "6",
        title: "蓝迪安全教育-06集：游泳的安全",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499393237329_39_1982.mp4",
      },
      {
        column: "7",
        title: "蓝迪安全教育-07集：游乐场的安全",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499393194162_39_1984.mp4",
      },
      {
        column: "8",
        title: "蓝迪安全教育-08集：一起玩玩具",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499393155897_39_1229.mp4",
      },
      {
        column: "9",
        title: "蓝迪安全教育-09集：一起踢足球",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499393121812_39_1834.mp4",
      },
      {
        column: "10",
        title: "蓝迪安全教育-10集：一起来跑步",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499393091858_39_123.mp4",
      },
      {
        column: "11",
        title: "蓝迪安全教育-11集：一起来吃糖葫芦",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499393062085_39_1410.mp4",
      },
      {
        column: "12",
        title: "蓝迪安全教育-12集：眼睛进沙子怎么办",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499393038114_39_1619.mp4",
      },
      {
        column: "13",
        title: "蓝迪安全教育-13集：鞋带开了，怎么办",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499393003431_39_1316.mp4",
      },
      {
        column: "14",
        title: "蓝迪安全教育-14集：小心烫伤",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392977813_39_1880.mp4",
      },
      {
        column: "15",
        title: "蓝迪安全教育-15集：小心陌生人",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392943445_39_1261.mp4",
      },
      {
        column: "16",
        title: "蓝迪安全教育-16集：小心夹手",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392916706_39_1916.mp4",
      },
      {
        column: "17",
        title: "蓝迪安全教育-17集：小手洗干净",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392880225_39_170.mp4",
      },
      {
        column: "18",
        title: "蓝迪安全教育-18集：下雨天，我要这样做",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392853242_39_1980.mp4",
      },
      {
        column: "19",
        title: "蓝迪安全教育-19集：下车应该注意什么",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392824893_39_1305.mp4",
      },
      {
        column: "20",
        title: "蓝迪安全教育-20集：我们来吃好吃的",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392769666_39_1416.mp4",
      },
      {
        column: "21",
        title: "蓝迪安全教育-21集：我们都爱吃糖",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392666037_39_1100.mp4",
      },
      {
        column: "22",
        title: "蓝迪安全教育-22集：我爱打篮球",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392637463_39_1810.mp4",
      },
      {
        column: "23",
        title: "蓝迪安全教育-23集：玩沙子的安全",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392598055_39_1603.mp4",
      },
      {
        column: "24",
        title: "蓝迪安全教育-24集：天气雾霾了",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392573638_39_1336.mp4",
      },
      {
        column: "25",
        title: "蓝迪安全教育-25集：天气冷热变化该怎么办",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392548568_39_1229.mp4",
      },
      {
        column: "26",
        title: "蓝迪安全教育-26集：水开了怎么办",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392518456_39_145.mp4",
      },
      {
        column: "27",
        title: "蓝迪安全教育-27集：摔碎东西怎么办",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392491491_39_1257.mp4",
      },
      {
        column: "28",
        title: "蓝迪安全教育-28集：手指划破怎么办？",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392462269_39_1338.mp4",
      },
      {
        column: "29",
        title: "蓝迪安全教育-29集：上下楼梯的安全",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392436696_39_1525.mp4",
      },
      {
        column: "30",
        title: "蓝迪安全教育-30集：认识安全标志",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392423525_39_1540.mp4",
      },
      {
        column: "31",
        title: "蓝迪安全教育-31集：秋千荡起来",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392390298_39_152.mp4",
      },
      {
        column: "32",
        title: "蓝迪安全教育-32集：看电视",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392349178_39_1108.mp4",
      },
      {
        column: "33",
        title: "蓝迪安全教育-33集：开门关门要小心",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392313460_39_1333.mp4",
      },
      {
        column: "34",
        title: "蓝迪安全教育-34集：剪刀咔嚓嚓",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392257695_39_1906.mp4",
      },
      {
        column: "35",
        title: "蓝迪安全教育-35集：会咬人的电风扇",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392207804_39_1360.mp4",
      },
      {
        column: "36",
        title: "蓝迪安全教育-36集：喝水时，要注意",
        url: "http://36.110.12.195:9080//video/2017/7/7/2017771499392168182_39_1872.mp4",
      },
      {
        column: "37",
        title: "蓝迪安全教育-37集：好朋友，你别哭",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392134446_39_1717.mp4",
      },
      {
        column: "38",
        title: "蓝迪安全教育-38集：好好走路",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392107376_39_1540.mp4",
      },
      {
        column: "39",
        title: "蓝迪安全教育-39集：好好来吃饭",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392079138_39_177.mp4",
      },
      {
        column: "40",
        title: "蓝迪安全教育-40集：过旋转门，应该注意什么",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392051113_39_1924.mp4",
      },
      {
        column: "41",
        title: "蓝迪安全教育-41集：过马路的安全",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499392024633_39_128.mp4",
      },
      {
        column: "42",
        title: "蓝迪安全教育-42集：感冒发烧了怎么办",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391990833_39_1912.mp4",
      },
      {
        column: "43",
        title: "蓝迪安全教育-43集：发生火灾怎么办",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391962961_39_1421.mp4",
      },
      {
        column: "44",
        title: "蓝迪安全教育-44集：电器的安全",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391938756_39_1284.mp4",
      },
      {
        column: "45",
        title: "蓝迪安全教育-45集：地震了怎么办",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391906008_39_1356.mp4",
      },
      {
        column: "46",
        title: "蓝迪安全教育-46集：厨房里的安全",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391882494_39_131.mp4",
      },
      {
        column: "47",
        title: "蓝迪安全教育-47集：吃饭的安全",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391853779_39_1221.mp4",
      },
      {
        column: "48",
        title: "蓝迪安全教育-48集：乘坐电梯的安全",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391834630_39_1655.mp4",
      },
      {
        column: "49",
        title: "蓝迪安全教育-49集：超市的安全",
        url: "http://36.110.12.195:9080//video/2017/7/7/2017771499391752873_39_1253.mp4",
      },
      {
        column: "50",
        title: "蓝迪安全教育-50集：不小心跌倒了",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391713625_39_1943.mp4",
      },
      {
        column: "51",
        title: "蓝迪安全教育-51集：不透气的塑料袋",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391686298_39_1363.mp4",
      },
      {
        column: "52",
        title: "蓝迪安全教育-52集：不熟悉的动物不乱摸",
        url: "http://36.110.12.195:9080//video/2017/7/7/2017771499391651043_39_1317.mp4",
      },
      {
        column: "53",
        title: "蓝迪安全教育-53集：不跟陌生人走",
        url: "http://36.110.12.195:9080//video/2017/7/7/2017771499391600349_39_1812.mp4",
      },
      {
        column: "54",
        title: "蓝迪安全教育-54集：被锁在车里怎么办",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391558154_39_1510.mp4",
      },
      {
        column: "55",
        title: "蓝迪安全教育-55集：保护眼睛",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391526922_39_1389.mp4",
      },
      {
        column: "56",
        title: "蓝迪安全教育-56集：安全用药",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391498229_39_1495.mp4",
      },
      {
        column: "57",
        title: "蓝迪安全教育-57集：安全玩跷跷板",
        url: "http://36.110.12.195:9080//video/2017/7/7/2017771499391455527_39_1199.mp4",
      },
      {
        column: "58",
        title: "蓝迪安全教育-58集：安全玩滑梯",
        url: "http://36.110.12.195:9080//video/2017/7/7/2017771499391429006_39_1316.mp4",
      },
      {
        column: "59",
        title: "蓝迪安全教育-59集：安全使用水果刀",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391401454_39_124.mp4",
      },
      {
        column: "60",
        title: "蓝迪安全教育-60集：安全使用铅笔",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391368783_39_1339.mp4",
      },
      {
        column: "61",
        title: "蓝迪安全教育-61集：安全上下楼梯",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391339584_39_1674.mp4",
      },
      {
        column: "62",
        title: "蓝迪安全教育-62集：安全来骑自行车",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391315289_39_1963.mp4",
      },
      {
        column: "63",
        title: "蓝迪安全教育-63集：安全滑轮滑",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391287798_39_1324.mp4",
      },
      {
        column: "64",
        title: "蓝迪安全教育-64集：安全过马路",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391262545_39_1751.mp4",
      },
      {
        column: "65",
        title: "蓝迪安全教育-65集：安全乘坐公共汽车",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391237599_39_1356.mp4",
      },
      {
        column: "66",
        title: "蓝迪安全教育-66集：安全乘坐电梯",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499391206469_39_1954.mp4",
      },
      {
        column: "67",
        title: "蓝迪安全教育-67集：乘车的安全",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499396638810_39_1868.mp4",
      },
    ],
  },
  {
    title: "鹿精灵",
    desc: "本片主人公小鹿迪尔是九色鹿王的后代，他父母是“灵木州”领地的鹿王，被饕餮族的达大王长期囚禁，并逼迫为其提供鹿王能量，更麻烦的是达大王还派了凶猛的饕餮战士王大明去抓捕迪尔，以消灭和他对抗的潜在威胁。少年迪尔决心接受挑战和使命，救出父母、保卫家园。他得到了五个领地使者的陪伴和帮助，在穿越五个领地的艰苦历程中，迪尔获得了特殊的力量；在经历了一系列考验和失败后，在朋友和其他精灵的帮助下，他获得了金、木、水、火、土五行的能量，最终来到金铁州战胜了达大王，救出了自己的父母。",
    list: [
      {
        column: "1",
        title: "鹿精灵_01_征程开始",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747077288_39_1174.mp4",
      },
      {
        column: "2",
        title: "鹿精灵_02_牺牲的意思",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747078669_39_1801.mp4",
      },
      {
        column: "3",
        title: "鹿精灵_03_奇异的水果",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747080121_39_1479.mp4",
      },
      {
        column: "4",
        title: "鹿精灵_04_森林传音",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747081423_39_1242.mp4",
      },
      {
        column: "5",
        title: "鹿精灵_05_智取胜蛮力",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747082964_39_1504.mp4",
      },
      {
        column: "6",
        title: "鹿精灵_06_乘坐彩虹",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747084725_39_1775.mp4",
      },
      {
        column: "7",
        title: "鹿精灵_07_未知世界的地图",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747086176_39_1963.mp4",
      },
      {
        column: "8",
        title: "鹿精灵_08_火鸟丽娅",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747100524_39_1105.mp4",
      },
      {
        column: "9",
        title: "鹿精灵_09_火的影子",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747101866_39_1787.mp4",
      },
      {
        column: "10",
        title: "鹿精灵_10_芥末改变了一切",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747103317_39_1518.mp4",
      },
      {
        column: "11",
        title: "鹿精灵_11_无限桥",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747104673_39_1525.mp4",
      },
      {
        column: "12",
        title: "鹿精灵_12_一帆风顺",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747105885_39_1167.mp4",
      },
      {
        column: "13",
        title: "鹿精灵_13_废城雅丹",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747107136_39_1844.mp4",
      },
      {
        column: "14",
        title: "鹿精灵_14_黑暗之光",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747108411_39_1448.mp4",
      },
      {
        column: "15",
        title: "鹿精灵_15_了不起的花",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747124007_39_1785.mp4",
      },
      {
        column: "16",
        title: "鹿精灵_16_预言",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747124469_39_1556.mp4",
      },
      {
        column: "17",
        title: "鹿精灵_17_暗流涌动",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747124811_39_1306.mp4",
      },
      {
        column: "18",
        title: "鹿精灵_18_彩虹之上",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747125218_39_1359.mp4",
      },
      {
        column: "19",
        title: "鹿精灵_19_去奶奶家",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747125578_39_1443.mp4",
      },
      {
        column: "20",
        title: "鹿精灵_20_重获法力",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747125953_39_1522.mp4",
      },
      {
        column: "21",
        title: "鹿精灵_21_神秘圆点",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747126512_39_1658.mp4",
      },
      {
        column: "22",
        title: "鹿精灵_22_刁蛮的火鸟",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747141750_39_1836.mp4",
      },
      {
        column: "23",
        title: "鹿精灵_23_龙之火焰",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747142361_39_1629.mp4",
      },
      {
        column: "24",
        title: "鹿精灵_24_命中注定",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747142689_39_1303.mp4",
      },
      {
        column: "25",
        title: "鹿精灵_25_丽娅重生",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747143163_39_1845.mp4",
      },
      {
        column: "26",
        title: "鹿精灵_26_晶石钥匙",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747143542_39_1648.mp4",
      },
      {
        column: "27",
        title: "鹿精灵_27_真假芥末",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747143933_39_1281.mp4",
      },
      {
        column: "28",
        title: "鹿精灵_28_雪雕归来",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747144373_39_1405.mp4",
      },
      {
        column: "29",
        title: "鹿精灵_29_禁忌水域",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747160744_39_1459.mp4",
      },
      {
        column: "30",
        title: "鹿精灵_30_最后一块太阳宝石",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747162016_39_1506.mp4",
      },
      {
        column: "31",
        title: "鹿精灵_31_通缉小鹿",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747163251_39_1629.mp4",
      },
      {
        column: "32",
        title: "鹿精灵_32_两件小东西",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747164586_39_116.mp4",
      },
      {
        column: "33",
        title: "鹿精灵_33_牦牛的游戏",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747165896_39_1681.mp4",
      },
      {
        column: "34",
        title: "鹿精灵_34_达大王的思想球",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747167127_39_1967.mp4",
      },
      {
        column: "35",
        title: "鹿精灵_35_雪猴子村庄",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747168451_39_1799.mp4",
      },
      {
        column: "36",
        title: "鹿精灵_36_鹿姑娘",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747184442_39_1821.mp4",
      },
      {
        column: "37",
        title: "鹿精灵_37_蓝宝的法力",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747185826_39_1719.mp4",
      },
      {
        column: "38",
        title: "鹿精灵_38_国王的故事",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747186974_39_1386.mp4",
      },
      {
        column: "39",
        title: "鹿精灵_39_裂云飞龙来袭（上)",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747188324_39_1396.mp4",
      },
      {
        column: "40",
        title: "鹿精灵_40_裂云飞龙来袭（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747189515_39_112.mp4",
      },
      {
        column: "41",
        title: "鹿精灵_41_不完美的逃亡",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747190702_39_1796.mp4",
      },
      {
        column: "42",
        title: "鹿精灵_42_狂野大赛",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747191954_39_1803.mp4",
      },
      {
        column: "43",
        title: "鹿精灵_43_卧底达大王",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747207406_39_1950.mp4",
      },
      {
        column: "44",
        title: "鹿精灵_44_友好的较量",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747208661_39_1371.mp4",
      },
      {
        column: "45",
        title: "鹿精灵_45_黑暗的诱惑",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747209978_39_1966.mp4",
      },
      {
        column: "46",
        title: "鹿精灵_46_争夺传送门",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747211392_39_1368.mp4",
      },
      {
        column: "47",
        title: "鹿精灵_47_芥末的身世",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747212635_39_1207.mp4",
      },
      {
        column: "48",
        title: "鹿精灵_48_丽娅对吉雅",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747213705_39_1745.mp4",
      },
      {
        column: "49",
        title: "鹿精灵_49_当一天国王",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747214985_39_1377.mp4",
      },
      {
        column: "50",
        title: "鹿精灵_50_芥末的牺牲",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747228462_39_1775.mp4",
      },
      {
        column: "51",
        title: "鹿精灵_51_孤立无援的女王",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747229773_39_1474.mp4",
      },
      {
        column: "52",
        title: "鹿精灵_52_最终的决战",
        url: "http://vskd.bj.bcebos.com//video/2017/12/20/201712201513747231222_39_1737.mp4",
      },
    ],
  },
  {
    title: "科普中国之酷杰的科学之旅",
    desc: "神奇的环形世界，生活着一群奇特的小人，他们身材矮小，只有正常人的拇指大小，但是他们却拥有令人向往的超能力。他们用超能力创造着美好生活。而这里的孩子每年都要经历一场残酷而艰难的考验，超能力考试，属于他们的成年礼。",
    list: [
      {
        column: "1",
        title: "《酷杰的科学之旅》第01集：特殊的惩罚",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661294307_39_1718.mp4",
      },
      {
        column: "2",
        title: "《酷杰的科学之旅》第02集：可怕的鼻涕菜",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661294767_39_1501.mp4",
      },
      {
        column: "3",
        title: "《酷杰的科学之旅》第03集：树冠逃生",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661295076_39_1580.mp4",
      },
      {
        column: "4",
        title: "《酷杰的科学之旅》第04集：池塘怪兽题",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661295546_39_1393.mp4",
      },
      {
        column: "5",
        title: "《酷杰的科学之旅》第05集：身陷泥潭",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661295998_39_1668.mp4",
      },
      {
        column: "6",
        title: "《酷杰的科学之旅》第06集：救命的臭味",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661296339_39_1285.mp4",
      },
      {
        column: "7",
        title: "《酷杰的科学之旅》第07集：险地寻药",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661296847_39_1355.mp4",
      },
      {
        column: "8",
        title: "《酷杰的科学之旅》第08集：水上行走",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661313834_39_1499.mp4",
      },
      {
        column: "9",
        title: "《酷杰的科学之旅》第09集：多眼怪兽",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661314218_39_162.mp4",
      },
      {
        column: "10",
        title: "《酷杰的科学之旅》第10集：果实内的旅行",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661314569_39_1769.mp4",
      },
      {
        column: "11",
        title: "《酷杰的科学之旅》第11集：与兽齐飞",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661314951_39_1596.mp4",
      },
      {
        column: "12",
        title: "《酷杰的科学之旅》第12集：蛛网历险记",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661315229_39_1769.mp4",
      },
      {
        column: "13",
        title: "《酷杰的科学之旅》第13集：暗夜杀手",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661315624_39_1840.mp4",
      },
      {
        column: "14",
        title: "《酷杰的科学之旅》第14集：摆脱恶鹰",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661315910_39_1706.mp4",
      },
      {
        column: "15",
        title: "《酷杰的科学之旅》第15集：完美防御",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661328976_39_1206.mp4",
      },
      {
        column: "16",
        title: "《酷杰的科学之旅》第16集：无声的杀手",
        url: "http://vskd.bj.bcebos.com//video/2017/9/6/2017961504661329338_39_1186.mp4",
      },
    ],
  },
  {
    title: "科普中国之阿U学科学",
    desc: "本片描述了以阿U为主的一群小朋友，他们对于自然和社会生活充满好奇，并进行积极的探索，通过老师和家长的解答，了解了很多有趣的科学小知识。全片幽默搞笑又不失严谨的科学态度，让孩子们在欢笑中学到知识，真正做到寓教于乐。",
    list: [
      {
        column: "1",
        title: "《阿U学科学》01集：一滴水中有多少奇妙的生命",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499320901033_39_124.mp4",
      },
      {
        column: "2",
        title: "《阿U学科学》03集：你在妈妈肚子里是什么样子的",
        url: "http://vskd.bj.bcebos.com//video/2017/7/18/20177181500364063442_39_1436.mp4",
      },
      {
        column: "2",
        title: "《阿U学科学》02集：人是从哪里来的",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499320951176_39_1227.mp4",
      },
      {
        column: "4",
        title: "《阿U学科学》04集：疫苗能打一针管一生吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499320981468_39_114.mp4",
      },
      {
        column: "5",
        title: "《阿U学科学》05集：打哈欠会传染吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321025821_39_1919.mp4",
      },
      {
        column: "6",
        title: "《阿U学科学》06集：我们和它们看到的世界一样吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321058721_39_14.mp4",
      },
      {
        column: "7",
        title: "《阿U学科学》07集：毛毛虫也能伪装成毒蛇吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321096444_39_1229.mp4",
      },
      {
        column: "8",
        title: "《阿U学科学》08集：蜗牛也有左撇子吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321120672_39_1520.mp4",
      },
      {
        column: "9",
        title: "《阿U学科学》09集：盐也会引发战争吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321271395_39_116.mp4",
      },
      {
        column: "10",
        title: "《阿U学科学》10集：斑马是黑斑白马还是白斑黑马",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321302185_39_1343.mp4",
      },
      {
        column: "11",
        title: "《阿U学科学》11集：真有吃人的植物吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321362254_39_1661.mp4",
      },
      {
        column: "12",
        title: "《阿U学科学》12集：宇宙起源于一次爆炸吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321416721_39_1637.mp4",
      },
      {
        column: "13",
        title: "《阿U学科学》13集：人类能找到“第二家园”吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321476984_39_1766.mp4",
      },
      {
        column: "14",
        title: "《阿U学科学》14集：蜗牛的“远亲”有多远",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321542592_39_1302.mp4",
      },
      {
        column: "15",
        title: "《阿U学科学》15集：在家也能挖矿山吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321593821_39_161.mp4",
      },
      {
        column: "16",
        title: "《阿U学科学》16集：0和1的世界有多神奇",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321626429_39_147.mp4",
      },
      {
        column: "17",
        title: "《阿U学科学》17集：猫咪睡觉时为什么把身体蜷成团",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321652776_39_1684.mp4",
      },
      {
        column: "18",
        title: "《阿U学科学》18集：先抓阄一定占优势吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321677283_39_1957.mp4",
      },
      {
        column: "19",
        title: "《阿U学科学》19集：智慧校园里的生活是怎样的",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321702951_39_1389.mp4",
      },
      {
        column: "20",
        title: "《阿U学科学》20集：机器人也会“闹脾气”吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321826053_39_1658.mp4",
      },
      {
        column: "21",
        title: "《阿U学科学》21集：屁也是清洁能源吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321882583_39_1281.mp4",
      },
      {
        column: "22",
        title: "《阿U学科学》22集：阿基米德要是不洗澡，就发现不了皇冠的秘密吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321941865_39_1708.mp4",
      },
      {
        column: "23",
        title: "《阿U学科学》23集：隐身人能从传说走向现实吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499321977252_39_1512.mp4",
      },
      {
        column: "24",
        title: "《阿U学科学》24集：水真的知道答案吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499322003917_39_1897.mp4",
      },
      {
        column: "25",
        title: "《阿U学科学》25集：动物自带指南针吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499322071490_39_1813.mp4",
      },
      {
        column: "26",
        title: "《阿U学科学》26集：为什么日出和日落时的太阳是红色的",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499322154077_39_1156.mp4",
      },
      {
        column: "27",
        title: "《阿U学科学》27集：诺贝尔为什么设立和平奖",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499322275232_39_1464.mp4",
      },
      {
        column: "28",
        title: "《阿U学科学》28集：猛犸象还能复活吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499322301954_39_1927.mp4",
      },
      {
        column: "29",
        title: "《阿U学科学》29集：心脏能“打印”出来吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499322350840_39_1440.mp4",
      },
      {
        column: "30",
        title: "《阿U学科学》30集：防毒面具为何长得像猪鼻子",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499322380449_39_1329.mp4",
      },
      {
        column: "31",
        title: "《阿U学科学》31集：星座能决定人的性格与命运吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499322406238_39_180.mp4",
      },
      {
        column: "32",
        title: "《阿U学科学》32集：如何像科学家一样思考",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499322453826_39_1935.mp4",
      },
    ],
  },
  {
    title: "科普中国之小樱桃读科学",
    desc: "在一个名叫樱桃市的小城里，有一位小学四年级学生小樱桃，她在成长过程中遇到了一系列乐趣和烦恼…",
    list: [
      {
        column: "1",
        title: "《小樱桃系列》01集：为什么要保护生物多样性",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499666995641_39_1358.mp4",
      },
      {
        column: "2",
        title: "《小樱桃系列》02集：为什么要提防外来物种入侵",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499667026187_39_119.mp4",
      },
      {
        column: "3",
        title: "《小樱桃系列》03集：为什么说地球生命在不断进化",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499667204283_39_1695.mp4",
      },
      {
        column: "4",
        title: "《小樱桃系列》04集：基因分好坏吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499667227872_39_119.mp4",
      },
      {
        column: "5",
        title: "《小樱桃系列》05集：干细胞到底有什么用",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499667252978_39_1973.mp4",
      },
      {
        column: "6",
        title: "《小樱桃系列》06集：靠克隆技术能复制爱因斯坦吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499667361781_39_1979.mp4",
      },
      {
        column: "7",
        title: "《小樱桃系列》07集：光喝蒸馏水好不好",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499667498308_39_1296.mp4",
      },
      {
        column: "8",
        title: "《小樱桃系列》08集：反复加热过的油为什么不宜食用",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499667610874_39_1604.mp4",
      },
      {
        column: "9",
        title: "《小樱桃系列》09集：体检究竟是查疾病还是查健康",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499667688753_39_1688.mp4",
      },
      {
        column: "10",
        title: "《小樱桃系列》10集：为什么吸烟者易患冠心病",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499667776555_39_1508.mp4",
      },
      {
        column: "11",
        title: "《小樱桃系列》11集：为什么降压药不能吃吃停停",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499667796820_39_1691.mp4",
      },
      {
        column: "12",
        title: "《小樱桃系列》12集：癌症会传染或遗传吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499667874178_39_1531.mp4",
      },
      {
        column: "13",
        title: "《小樱桃系列》13集：怎样跳广场舞才更有利于健康",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499667969369_39_1555.mp4",
      },
      {
        column: "14",
        title: "《小樱桃系列》14集：为什么地球会成为生命的乐园",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668016015_39_1696.mp4",
      },
      {
        column: "15",
        title: "《小樱桃系列》15集：空间天气预报有什么用",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668111293_39_1997.mp4",
      },
      {
        column: "16",
        title: "《小樱桃系列》16集：极端天气为什么越来越多了",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668164867_39_1827.mp4",
      },
      {
        column: "17",
        title: "《小樱桃系列》17集：地震可以准确预报吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668210066_39_1169.mp4",
      },
      {
        column: "18",
        title: "《小樱桃系列》18集：暴雨时该如何保证驾车安全",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668283350_39_1694.mp4",
      },
      {
        column: "19",
        title: "《小樱桃系列》19集：雷电喜欢选择哪些人",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668341394_39_1679.mp4",
      },
      {
        column: "20",
        title: "《小樱桃系列》20集：什么是城市热岛效应",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668377383_39_1381.mp4",
      },
      {
        column: "21",
        title: "《小樱桃系列》21集：城市污水去哪里了",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668410754_39_1447.mp4",
      },
      {
        column: "22",
        title: "《小樱桃系列》22集：光污染的影响仅仅是让星空消失吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668439195_39_1119.mp4",
      },
      {
        column: "23",
        title: "《小樱桃系列》23集：为什么把公园绿地称作城市的“肺”",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668476272_39_1529.mp4",
      },
      {
        column: "24",
        title: "《小樱桃系列》24集：为什么必须节约利用淡水资源",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668508833_39_1897.mp4",
      },
      {
        column: "25",
        title: "《小樱桃系列》25集：城市居民如何预防和应对火灾",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668606416_39_1428.mp4",
      },
      {
        column: "26",
        title: "《小樱桃系列》26集：怎样进行台风预警",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668707684_39_1931.mp4",
      },
      {
        column: "27",
        title: "《小樱桃系列》27集：为什么说传销宣传中的“倍增”神话很不靠谱",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668738307_39_1541.mp4",
      },
      {
        column: "28",
        title: "《小樱桃系列》28集：彩票分析师的话可信吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668869373_39_1571.mp4",
      },
      {
        column: "29",
        title: "《小樱桃系列》29集：为什么中了“木马”后，计算机就可能被别人控制",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499668935939_39_1165.mp4",
      },
      {
        column: "30",
        title: "《小樱桃系列》30集：电子银行采取了哪些安全措施",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669086087_39_1670.mp4",
      },
      {
        column: "31",
        title: "《小樱桃系列》31集：网络使人们的距离变近了还是变远了",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669116037_39_1943.mp4",
      },
      {
        column: "32",
        title: "《小樱桃系列》32集：大数据究竟有什么用途",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669161786_39_1450.mp4",
      },
      {
        column: "33",
        title: "《小樱桃系列》33集：用微波炉烹饪安全吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669224310_39_1972.mp4",
      },
      {
        column: "34",
        title: "《小樱桃系列》34集：身份证、银行卡和交通卡是怎样储存信息的",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669262307_39_1941.mp4",
      },
      {
        column: "35",
        title: "《小樱桃系列》35集：提倡错峰用电仅仅是为了节约电费吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669297438_39_1265.mp4",
      },
      {
        column: "36",
        title: "《小樱桃系列》36集：为什么要提倡绿色能源",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669342419_39_1431.mp4",
      },
      {
        column: "37",
        title: "《小樱桃系列》37集：为什么要开展“无车日”活动",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669375562_39_1771.mp4",
      },
      {
        column: "38",
        title: "《小樱桃系列》38集：为什么“嫦娥”要奔向月球",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669414179_39_134.mp4",
      },
      {
        column: "39",
        title: "《小樱桃系列》39集：物联网是怎样把世界联系起来的",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669452310_39_1776.mp4",
      },
      {
        column: "40",
        title: "《小樱桃系列》40集：社区居民可以用移动互联网做些什么",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669495458_39_1116.mp4",
      },
      {
        column: "41",
        title: "《小樱桃系列》41集：发达的人工智能可能是一个真正的危险吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669544856_39_1867.mp4",
      },
      {
        column: "42",
        title: "《小樱桃系列》42集：建筑物是怎么保护我们的",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669589549_39_193.mp4",
      },
      {
        column: "43",
        title: "《小樱桃系列》43集：全球变暖是人类活动造成的吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669636357_39_1815.mp4",
      },
      {
        column: "44",
        title: "《小樱桃系列》44集：地球究竟能养活多少人",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669693114_39_1796.mp4",
      },
      {
        column: "45",
        title: "《小樱桃系列》45集：星座能决定人的命运吗",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499669733520_39_1420.mp4",
      },
      {
        column: "47",
        title: "《小樱桃系列》47集：社区居民为什么要懂点科学方法",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499670051362_39_1382.mp4",
      },
      {
        column: "48",
        title: "《小樱桃系列》48集：为什么要崇尚科学，但又不迷信科学",
        url: "http://vskd.bj.bcebos.com//video/2017/7/10/20177101499670081791_39_1452.mp4",
      },
    ],
  },

  {
    title: "科普中国之可可小爱",
    desc: "《可可小爱》以清新时尚、活泼可爱的动漫宝贝可可和小爱，来演绎公民道德、生态环保、人文关怀、文明礼仪、少儿品德培育、安全教育等爱心公益主题故事。为全国首部500集大规模、定位“弘扬美德、传播文明”的爱心公益动漫品牌。",
    list: [
      {
        column: "1",
        title: "可可小爱儿童应急安全-第01集《横穿马路有危险_走人行道保安全》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175100154_39_1765.mp4",
      },
      {
        column: "2",
        title: "可可小爱儿童应急安全-第02集《结伴游泳很危险_大人陪伴才安全》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175100444_39_1523.mp4",
      },
      {
        column: "3",
        title: "可可小爱儿童应急安全-第03集《安全通道要通畅_检查预防记心上》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175100724_39_1631.mp4",
      },
      {
        column: "4",
        title: "可可小爱儿童应急安全-第04集《安全带作用大_上车请您系好它》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175100974_39_1276.mp4",
      },
      {
        column: "5",
        title: "可可小爱儿童应急安全-第05集《地震无情预报难_多学知识免伤害》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175101250_39_1781.mp4",
      },
      {
        column: "6",
        title: "可可小爱儿童应急安全-第06集《生命安全第一_请勿疲劳驾驶》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175101597_39_1853.mp4",
      },
      {
        column: "7",
        title: "可可小爱儿童应急安全-第07集《人身安全第一_请勿高空抛物》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175101849_39_1137.mp4",
      },
      {
        column: "8",
        title: "可可小爱儿童应急安全-第08集《至关生命安全_请勿高空抛物》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175120166_39_1312.mp4",
      },
      {
        column: "9",
        title: "可可小爱儿童应急安全-第09集《安全号码_守护大家》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175120438_39_1676.mp4",
      },
      {
        column: "10",
        title: "可可小爱儿童应急安全-第10集《建文明小区_勿高空抛物》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175120675_39_1996.mp4",
      },
      {
        column: "11",
        title: "可可小爱儿童应急安全-第11集《自驾出行_安全第一》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175120976_39_1472.mp4",
      },
      {
        column: "12",
        title: "可可小爱儿童应急安全-第12集《自驾旅游欢乐多_安全行车是保障》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175121259_39_1211.mp4",
      },
      {
        column: "13",
        title: "可可小爱儿童应急安全-第13集《乘车多注意_安全你我他》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175121518_39_1474.mp4",
      },
      {
        column: "14",
        title: "可可小爱儿童应急安全-第14集《景区美景心舒畅_安全意识莫放松》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175121788_39_1365.mp4",
      },
      {
        column: "15",
        title: "可可小爱儿童应急安全-第15集《景区人多防踩踏_谨遵提示莫拥挤》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175148554_39_1414.mp4",
      },
      {
        column: "16",
        title: "可可小爱儿童应急安全-第16集《水上活动有危险_谨慎下水保安全》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175148835_39_1148.mp4",
      },
      {
        column: "17",
        title:
          "可可小爱儿童应急安全-第17集《健康畅游网络世界_拒绝不良网站信息》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175149073_39_1179.mp4",
      },
      {
        column: "18",
        title: "可可小爱儿童应急安全-第18集《做健康餐饮_远离地沟油》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175149316_39_1414.mp4",
      },
      {
        column: "19",
        title: "可可小爱儿童应急安全-第19集《景区旅游遵提示_安全畅游快乐多》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175149577_39_1632.mp4",
      },
      {
        column: "20",
        title: "可可小爱儿童应急安全-第20集《身遇火险勿惊慌_安全有序要牢记》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175149832_39_1771.mp4",
      },
      {
        column: "21",
        title: "可可小爱儿童应急安全-第21集《佳节喜团圆_防火保安全》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175150081_39_1946.mp4",
      },
      {
        column: "22",
        title: "可可小爱儿童应急安全-第22集《迎佳节_保安全_齐防盗》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175172185_39_1556.mp4",
      },
      {
        column: "23",
        title: "可可小爱儿童应急安全-第23集《春节出行忙_安全记心上》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175172456_39_1555.mp4",
      },
      {
        column: "24",
        title: "可可小爱儿童应急安全-第24集《雾霾天气_行车注意安全》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175172713_39_1509.mp4",
      },
      {
        column: "25",
        title: "可可小爱儿童应急安全-第25集《生命安全第一_请勿疲劳驾驶》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175172951_39_1803.mp4",
      },
      {
        column: "26",
        title: "可可小爱儿童应急安全-第26集《关电关气关门窗_防火防盗保安全》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175173204_39_1313.mp4",
      },
      {
        column: "27",
        title: "可可小爱儿童应急安全-第27集《安全通道能救命_畅通无阻保安全》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175173444_39_1407.mp4",
      },
      {
        column: "28",
        title: "可可小爱儿童应急安全-第28集《旅游_不坐无证照的交通工具》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175173686_39_1101.mp4",
      },
      {
        column: "29",
        title: "可可小爱公益环保-第01集《淋浴节水_低碳又环保》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175226827_39_1641.mp4",
      },
      {
        column: "30",
        title: "可可小爱公益环保-第02集《保护野生动物_抵制违禁皮毛衣》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175227179_39_1116.mp4",
      },
      {
        column: "31",
        title: "可可小爱公益环保-第03集《保护环境_不乱排污》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175227464_39_1232.mp4",
      },
      {
        column: "32",
        title: "可可小爱公益环保-第04集《上班少开车_低碳又环保》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175227918_39_1263.mp4",
      },
      {
        column: "33",
        title: "可可小爱公益环保-第05集《秀出您的环保搭档》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175228432_39_1893.mp4",
      },
      {
        column: "34",
        title: "可可小爱公益环保-第06集《多用节能灯_省电省钱又环保》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175228743_39_1789.mp4",
      },
      {
        column: "35",
        title: "可可小爱公益环保-第07集《珍惜树木纸张_尽量双面打印》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175229109_39_1689.mp4",
      },
      {
        column: "36",
        title: "可可小爱公益环保-第08集《不乱丢垃圾_环境更美丽》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175256755_39_149.mp4",
      },
      {
        column: "37",
        title: "可可小爱公益环保-第09集《旧电池勿乱丢_请投电池回收桶》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175257045_39_1703.mp4",
      },
      {
        column: "38",
        title: "可可小爱公益环保-第10集《绿化地球环境_多多植树造林》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175257339_39_1156.mp4",
      },
      {
        column: "39",
        title: "可可小爱公益环保-第11集《净水来之不易_珍惜点点滴滴》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175257643_39_1418.mp4",
      },
      {
        column: "40",
        title: "可可小爱公益环保-第12集《一次性筷子浪费大_爱惜树木不用它》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175257928_39_1241.mp4",
      },
      {
        column: "41",
        title: "可可小爱公益环保-第13集《关注自然生态_拒食野生动物》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175258219_39_1527.mp4",
      },
      {
        column: "42",
        title: "可可小爱公益环保-第14集《垃圾分类意义大_请您积极配合它》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175258528_39_1297.mp4",
      },
      {
        column: "43",
        title: "可可小爱公益环保-第15集《拒食野生动物_维护生态环境》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175281519_39_1212.mp4",
      },
      {
        column: "44",
        title: "可可小爱公益环保-第16集《水资源_请珍惜_重复利用我做起》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175281812_39_1142.mp4",
      },
      {
        column: "45",
        title: "可可小爱公益环保-第17集《自带水壶喝水_低碳环保省钱》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175282050_39_1253.mp4",
      },
      {
        column: "46",
        title: "可可小爱公益环保-第18集《爱护江河_勿丢垃圾》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175282292_39_1532.mp4",
      },
      {
        column: "47",
        title: "可可小爱公益环保-第19集《街道讲卫生_不留宠物便》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175282535_39_1883.mp4",
      },
      {
        column: "48",
        title: "可可小爱公益环保-第20集《文明遛狗_维护环境》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175282772_39_1417.mp4",
      },
      {
        column: "49",
        title: "可可小爱公益环保-第21集《野外带走垃圾_留下自然美景》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175283023_39_1970.mp4",
      },
      {
        column: "50",
        title: "可可小爱公益环保-第22集《防治雾霾_请爱护森林》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175313689_39_1469.mp4",
      },
      {
        column: "51",
        title: "可可小爱公益环保-第23集《花儿也有家_爱它不采它》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175313941_39_1200.mp4",
      },
      {
        column: "52",
        title: "可可小爱公益环保-第24集《科学放生_为漓江增殖》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175314171_39_1310.mp4",
      },
      {
        column: "53",
        title: "可可小爱公益环保-第25集《爱护环境_守护和谐家园》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175314404_39_1476.mp4",
      },
      {
        column: "54",
        title: "可可小爱公益环保-第26集《清洁漓江垃圾_保护美丽家园》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175314653_39_1121.mp4",
      },
      {
        column: "55",
        title: "可可小爱公益环保-第27集《植树造林_为漓江增色》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175314898_39_1358.mp4",
      },
      {
        column: "56",
        title: "可可小爱公益环保-第28集《绿色出行_爱护美丽家园》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175315181_39_1423.mp4",
      },
      {
        column: "57",
        title: "可可小爱公益环保-第29集《保护珍稀动物_与自然和谐共处》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175331695_39_1103.mp4",
      },
      {
        column: "58",
        title: "可可小爱科普系列-第01集《生命很脆弱_酒后不开车》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175347021_39_1697.mp4",
      },
      {
        column: "59",
        title: "可可小爱科普系列-第02集《雾霾较重时_老幼少出门》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175347305_39_1877.mp4",
      },
      {
        column: "60",
        title: "可可小爱科普系列-第03集《尊重知识产权_请支持正版》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175347575_39_1584.mp4",
      },
      {
        column: "61",
        title: "可可小爱科普系列-第04集《雾霾多发季_出行看天气》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175347856_39_1286.mp4",
      },
      {
        column: "62",
        title: "可可小爱科普系列-第05集《爱护候鸟资源_捕猎候鸟违法》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175348127_39_1496.mp4",
      },
      {
        column: "63",
        title: "可可小爱科普系列-第06集《遵守安全法规_不带烟花爆竹乘车》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175348400_39_1134.mp4",
      },
      {
        column: "64",
        title: "可可小爱科普系列-第07集《尊重知识产权_大家远离盗版》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175348644_39_149.mp4",
      },
      {
        column: "65",
        title: "可可小爱科普系列-第08集《尊重知识产权_请勿经营盗版》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175365678_39_1332.mp4",
      },
      {
        column: "66",
        title: "可可小爱科普系列-第09集《雾霾不用怕_室内防霾讲方法》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175366000_39_1654.mp4",
      },
      {
        column: "67",
        title: "可可小爱科普系列-第10集《拒绝网络谣言_敢于担当发声》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175366383_39_1977.mp4",
      },
      {
        column: "68",
        title: "可可小爱科普系列-第11集《男女平等_反对就业歧视》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175366742_39_15.mp4",
      },
      {
        column: "69",
        title: "可可小爱科普系列-第12集《公民权利_人人平等》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175367135_39_1637.mp4",
      },
      {
        column: "70",
        title: "可可小爱科普系列-第13集《公正执法_不分亲疏》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175367405_39_1917.mp4",
      },
      {
        column: "71",
        title: "可可小爱科普系列-第14集《法律力量大_维权得靠它》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175367644_39_1571.mp4",
      },
      {
        column: "72",
        title: "可可小爱科普系列-第15集《善用法律_保护自己》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175386908_39_1316.mp4",
      },
      {
        column: "73",
        title: "可可小爱科普系列-第16集《言论自由_不可违法》、",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175387177_39_1489.mp4",
      },
      {
        column: "74",
        title: "可可小爱科普系列-第17集《公正严明_秉公执法》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175387472_39_1257.mp4",
      },
      {
        column: "75",
        title: "可可小爱科普系列-第18集《法律面前_人人平等》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175387752_39_1286.mp4",
      },
      {
        column: "76",
        title: "可可小爱科普系列-第19集《遵守法规_构建文明网络》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175388015_39_1167.mp4",
      },
      {
        column: "77",
        title: "可可小爱科普系列-第20集《不畏强权_维护法律尊严》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175388306_39_1175.mp4",
      },
      {
        column: "78",
        title: "可可小爱科普系列-第21集《依法维权_既是公民权利也是义务》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175388564_39_1368.mp4",
      },
      {
        column: "79",
        title: "可可小爱科普系列-第22集《公正选举_尊重你我他》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175410521_39_1246.mp4",
      },
      {
        column: "80",
        title: "可可小爱科普系列-第23集《少年强_则国强》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175410807_39_1971.mp4",
      },
      {
        column: "81",
        title: "可可小爱科普系列-第24集《珍惜民主权利_共建美好家园》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175411103_39_1473.mp4",
      },
      {
        column: "82",
        title: "可可小爱科普系列-第25集《尊重民主_包容个性》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175411439_39_1503.mp4",
      },
      {
        column: "83",
        title: "可可小爱科普系列-第26集《路通民富_民富国强》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175411704_39_1334.mp4",
      },
      {
        column: "84",
        title: "可可小爱科普系列-第27集《民族大家庭__美丽中国梦》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175411983_39_1135.mp4",
      },
      {
        column: "85",
        title: "可可小爱科普系列-第28集《按劳分配_平等不是平均》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175412241_39_1191.mp4",
      },
      {
        column: "86",
        title: "可可小爱科普系列-第29集《缅怀革命先烈_传承民族精神》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175433913_39_1792.mp4",
      },
      {
        column: "87",
        title: "可可小爱科普系列-第30集《改革开放促发展_祖国处处换新颜》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175434195_39_1108.mp4",
      },
      {
        column: "88",
        title: "可可小爱科普系列-第31集《广开监督渠道_人人献计献策》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175434505_39_1247.mp4",
      },
      {
        column: "89",
        title: "可可小爱科普系列-第32集《公正社会_均等分配优势资源》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175434751_39_1283.mp4",
      },
      {
        column: "90",
        title: "可可小爱科普系列-第33集《文明导游_持证上岗》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175435043_39_18.mp4",
      },
      {
        column: "91",
        title: "可可小爱科普系列-第34集《不强行要求旅客购物》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175435330_39_1966.mp4",
      },
      {
        column: "92",
        title: "可可小爱科普系列-第35集《旅游出行签合同_服务质量有保障》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175435613_39_1644.mp4",
      },
      {
        column: "93",
        title: "可可小爱科普系列-第36集《长寿圣殿_广西巴马》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175561985_39_1986.mp4",
      },
      {
        column: "94",
        title: "可可小爱科普系列-第37集《田园牧歌_龙胜梯田》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175562256_39_1639.mp4",
      },
      {
        column: "95",
        title: "可可小爱科普系列-第38集《桂林国际旅游胜地_山水与心灵同美》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175562525_39_1765.mp4",
      },
      {
        column: "96",
        title: "可可小爱科普系列-第39集《德天瀑布_天然山水画廊》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175562818_39_1337.mp4",
      },
      {
        column: "97",
        title: "可可小爱科普系列-第40集《百色_红色之旅》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175563086_39_1365.mp4",
      },
      {
        column: "98",
        title: "可可小爱科普系列-第41集《城市绿肺_南宁青秀山》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175563384_39_1328.mp4",
      },
      {
        column: "99",
        title: "可可小爱科普系列-第42集《度假胜地_广西北部湾》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175563698_39_1289.mp4",
      },
      {
        column: "100",
        title: "可可小爱科普系列-第43集《巧夺天工_三江程阳桥》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175607416_39_1747.mp4",
      },
      {
        column: "101",
        title: "可可小爱科普系列-第44集《峰丛古镇_梦境黄姚》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175607673_39_1519.mp4",
      },
      {
        column: "102",
        title: "可可小爱科普系列-第45集《天下第一滩_北海银滩》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175607957_39_1429.mp4",
      },
      {
        column: "103",
        title: "可可小爱科普系列-第46集《拥抱“互联网”打造“智慧税务》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175608249_39_1857.mp4",
      },
      {
        column: "104",
        title: "可可小爱科普系列-第47集《助力小微企业腾飞_构建富强中国梦》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175608548_39_1557.mp4",
      },
      {
        column: "105",
        title: "可可小爱科普系列-第48集《税收根本_取之于民_用之于民》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175608850_39_1821.mp4",
      },
      {
        column: "106",
        title: "可可小爱科普系列-第49集《珍爱生命_远离毒品》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175609171_39_1418.mp4",
      },
      {
        column: "107",
        title: "可可小爱科普系列-第50集《遭遇雾霾天_不宜户外锻炼》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175674956_39_1818.mp4",
      },
      {
        column: "108",
        title:
          "可可小爱科普系列-第51集《团体旅游不可擅自脱队_离队需全陪导游同意》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175675249_39_1678.mp4",
      },
      {
        column: "109",
        title: "可可小爱科普系列-第52集《乘坐竹筏遵守则_开心游乐有保障》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175675573_39_1913.mp4",
      },
      {
        column: "110",
        title: "可可小爱科普系列-第53集《人口流动_健康同行》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175675889_39_1145.mp4",
      },
      {
        column: "111",
        title: "可可小爱科普系列-第54集《掌握科学方法_坚持科学实践》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175676150_39_1859.mp4",
      },
      {
        column: "112",
        title: "可可小爱科普系列-第55集《人人遵法治_税收新局面》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175676398_39_1282.mp4",
      },
      {
        column: "113",
        title: "可可小爱科普系列-第56集《简政放权提效率_便民办税沐春风》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175676671_39_1160.mp4",
      },
      {
        column: "114",
        title: "可可小爱科普系列-第57集《坚持计划生育国策_实施全面两孩政策》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175702824_39_1792.mp4",
      },
      {
        column: "115",
        title: "可可小爱科普系列-第58集《弘扬宪法精神_建设法治吉林》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175703101_39_1892.mp4",
      },
      {
        column: "116",
        title: "可可小爱科普系列-第59集《遇到问题找法律_维护权益有保障》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175703350_39_12.mp4",
      },
      {
        column: "117",
        title: "可可小爱科普系列-第60集《法治宣传伴我成长》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175703665_39_1386.mp4",
      },
      {
        column: "118",
        title: "可可小爱科普系列-第61集《提升全民科学素质_共创和谐美好生活》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175703933_39_1470.mp4",
      },
      {
        column: "119",
        title: "可可小爱科普系列-第62集《反对家庭暴力_呵护美好生活》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175704165_39_1252.mp4",
      },
      {
        column: "120",
        title: "可可小爱科普系列-第63集《锻炼身体_增强体质》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175704436_39_1975.mp4",
      },
      {
        column: "121",
        title: "可可小爱科普系列-第64集《要爱不要“艾”炫酷更自护》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175730600_39_1180.mp4",
      },
      {
        column: "122",
        title: "可可小爱科普系列-第65集《防艾意识心中有_幸福生活保长久》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175730872_39_1605.mp4",
      },
      {
        column: "123",
        title: "可可小爱科普系列-第66集《爱心呵护生命_行动抵御艾滋》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175731121_39_1801.mp4",
      },
      {
        column: "124",
        title: "可可小爱科普系列-第67集《天上不会掉馅饼_非法集资是陷阱》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175731387_39_1588.mp4",
      },
      {
        column: "125",
        title: "可可小爱科普系列-第68集《保护自己_远离洗钱》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175731765_39_1194.mp4",
      },
      {
        column: "126",
        title: "可可小爱科普系列-第69集《全面两孩全家喜_幸福超越一加一》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175732050_39_1238.mp4",
      },
      {
        column: "127",
        title: "可可小爱科普系列-第70集《可可小爱鸡年贺岁片》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175732323_39_1333.mp4",
      },
      {
        column: "128",
        title: "可可小爱科普系列-第71集《探究科学知识_点燃科学之梦》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175753752_39_1926.mp4",
      },
      {
        column: "129",
        title: "可可小爱科普系列-第72集《白衣天使_敬业奉献_人人点赞》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175754044_39_1416.mp4",
      },
      {
        column: "130",
        title: "可可小爱儿童健康-第01集《多吃素好_健康环保》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175062159_39_180.mp4",
      },
      {
        column: "131",
        title: "可可小爱儿童健康-第02集《地沟油危害大_餐饮市场远离它》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175062459_39_1491.mp4",
      },
      {
        column: "132",
        title: "可可小爱儿童健康-第03集《做健康食品_远离违规添加剂》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175062706_39_1666.mp4",
      },
      {
        column: "133",
        title: "可可小爱儿童健康-第04集《假期爱护身体_请勿暴饮暴食》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175063176_39_1901.mp4",
      },
      {
        column: "134",
        title: "可可小爱儿童健康-第05集《吃饭前_洗手手_讲卫生的好习惯》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175063441_39_1169.mp4",
      },
      {
        column: "135",
        title: "可可小爱儿童健康-第06集《三无零食危害大_健康孩子远离它》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175063750_39_189.mp4",
      },
      {
        column: "136",
        title: "可可小爱儿童健康-第07集《爱清洁_讲卫生_健健康康不生病》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175064063_39_1697.mp4",
      },
      {
        column: "137",
        title: "可可小爱儿童健康-第08集《关注食品安全_不要过期食品》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175080557_39_1856.mp4",
      },
      {
        column: "138",
        title: "可可小爱儿童健康-第09集《饮食有度多运动_身体健康不肥胖》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175080799_39_1483.mp4",
      },
      {
        column: "139",
        title: "可可小爱儿童健康-第10集《旅途饮食重安全_正规店家更放心》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175081095_39_1163.mp4",
      },
      {
        column: "140",
        title: "可可小爱儿童健康-第11集《防雾霾_建议专用口罩》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175081383_39_1952.mp4",
      },
      {
        column: "141",
        title: "可可小爱儿童健康-第12集《多吃水果蔬菜_饮食也可防霾》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175081667_39_1857.mp4",
      },
      {
        column: "142",
        title: "可可小爱儿童健康-第13集《病情不夸大_诊断更准确》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175082012_39_1425.mp4",
      },
      {
        column: "143",
        title: "可可小爱儿童性格培养-第01集《青年当自强_不做啃老族》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175188333_39_1531.mp4",
      },
      {
        column: "144",
        title: "可可小爱儿童性格培养-第02集《自由飞翔一线牵》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175188603_39_1946.mp4",
      },
      {
        column: "145",
        title: "可可小爱儿童性格培养-第03集《自由非任性_生活有章法》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175188846_39_1551.mp4",
      },
      {
        column: "146",
        title: "可可小爱儿童性格培养-第04集《男女平等_尊重性别差异》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175189101_39_1377.mp4",
      },
      {
        column: "147",
        title: "可可小爱儿童性格培养-第05集《男女平等_家务一起分担》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175189349_39_1779.mp4",
      },
      {
        column: "148",
        title: "可可小爱儿童性格培养-第06集《做自尊_自信_自立_自强的新女性》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175189614_39_187.mp4",
      },
      {
        column: "149",
        title: "可可小爱儿童性格培养-第07集《阅读让我成长》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175189899_39_1521.mp4",
      },
      {
        column: "150",
        title: "可可小爱儿童性格培养-第08集《保持童真_享受童趣》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175208128_39_1891.mp4",
      },
      {
        column: "151",
        title: "可可小爱儿童性格培养-第09集《念父母孤独_常回家探亲》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175208443_39_1154.mp4",
      },
      {
        column: "152",
        title: "可可小爱儿童性格培养-第10集《爱护儿童身心_选健康影视节目》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175208674_39_1665.mp4",
      },
      {
        column: "153",
        title: "可可小爱儿童性格培养-第11集《关爱留守儿童_让心灵不再孤单》",
        url: "http://vskd.bj.bcebos.com//video/2017/8/8/2017881502175208918_39_1233.mp4",
      },
    ],
  },

  {
    title: "小破孩儿禁毒系列",
    desc: "小破孩和小丫遇到了一个神秘人,他有很多神奇的药丸,有的美容瘦身,有的能变身超人……要不要尝试一下呢?小破孩和小丫举棋不定…… ...",
    list: [
      {
        column: "1",
        title: "《小破孩禁毒系列》01集：我是牛人",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499412752894_39_1607.mp4",
      },
      {
        column: "2",
        title: "《小破孩禁毒系列》02集：小丫减肥",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499412847644_39_1632.mp4",
      },
      {
        column: "3",
        title: "《小破孩禁毒系列》03集：破孩溜冰",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499412941912_39_1699.mp4",
      },
      {
        column: "4",
        title: "《小破孩禁毒系列》04集：缉毒神探",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499413026884_39_170.mp4",
      },
      {
        column: "5",
        title: "《小破孩禁毒系列》05集：运毒",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499413121347_39_1440.mp4",
      },
      {
        column: "6",
        title: "《小破孩禁毒系列》06集：追星",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499413212392_39_1161.mp4",
      },
      {
        column: "7",
        title: "《小破孩禁毒系列》07集：借钱",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499413305497_39_143.mp4",
      },
      {
        column: "8",
        title: "《小破孩禁毒系列》08集：立功",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499413454374_39_1486.mp4",
      },
      {
        column: "9",
        title: "《小破孩禁毒系列》09集：半截烟囱",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499413595326_39_1634.mp4",
      },
      {
        column: "10",
        title: "《小破孩禁毒系列》10集：通关诡计",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499414083343_39_1550.mp4",
      },
      {
        column: "11",
        title: "《小破孩禁毒系列》11集：烫手邮包",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499414227515_39_177.mp4",
      },
      {
        column: "12",
        title: "《小破孩禁毒系列》12集：神秘乘客",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499414379557_39_1699.mp4",
      },
      {
        column: "13",
        title: "《小破孩禁毒系列》13集：危险毒驾",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499414444526_39_1416.mp4",
      },
      {
        column: "14",
        title: "《小破孩禁毒系列》14集：明星的秘密",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499414505993_39_1136.mp4",
      },
      {
        column: "15",
        title: "《小破孩禁毒系列》15集：诡异的冰糖",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499414584496_39_1228.mp4",
      },
      {
        column: "16",
        title: "《小破孩禁毒系列》16集：猪总的沉浮",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499414651939_39_1718.mp4",
      },
      {
        column: "17",
        title: "《小破孩禁毒系列》17集：流行锤",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499414730783_39_1907.mp4",
      },
      {
        column: "18",
        title: "《小破孩禁毒系列》18集：猪大胆",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499414796322_39_1587.mp4",
      },
      {
        column: "19",
        title: "《小破孩禁毒系列》19集：大表哥",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499414859914_39_129.mp4",
      },
      {
        column: "20",
        title: "《小破孩禁毒系列》20集：金左手",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499414927354_39_1172.mp4",
      },
      {
        column: "21",
        title: "《小破孩禁毒系列》21集：毒侠",
        url: "http://vskd.bj.bcebos.com//video/2017/7/7/2017771499416266053_39_1725.mp4",
      },
    ],
  },

  {
    title: "《聪明的顺溜》第一季",
    desc: "该剧以强国梦、强军梦为大的时代背景，以部队军事斗争准备生动实践和基层火热生活为基本素材，描述了士兵“顺溜”及其战友等新生代士兵在训练演习和工作生活中，用机智克服困难、用妙招帮助战友、用勇气完成任务的一系列生动鲜活小故事，通过“小士兵”的“大智慧”，展现当代青年官兵的高尚追求和苦练精兵练打赢的昂扬斗志，极具鲜明的时代特征和军营特色。",
    list: [
      {
        column: "1",
        title: "《聪明的顺溜》第01集：兵王传说 上",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499323567929_39_1704.mp4",
      },
      {
        column: "2",
        title: "《聪明的顺溜》第02集：兵王传说 下",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499323671378_39_1598.mp4",
      },
      {
        column: "3",
        title: "《聪明的顺溜》第03集：菜鸟入营",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499323763218_39_1136.mp4",
      },
      {
        column: "4",
        title: "《聪明的顺溜》第04集：尚誉绝对实力",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499323823005_39_1357.mp4",
      },
      {
        column: "5",
        title: "《聪明的顺溜》第05集：双面赵婧",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499323886450_39_1287.mp4",
      },
      {
        column: "6",
        title: "《聪明的顺溜》第06集：尚誉的秘诀",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499323948281_39_1108.mp4",
      },
      {
        column: "7",
        title: "《聪明的顺溜》第07集：旋转的子弹",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499324012217_39_1553.mp4",
      },
      {
        column: "8",
        title: "《聪明的顺溜》第08集：顺溜的怪招",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499324075811_39_1368.mp4",
      },
      {
        column: "9",
        title: "《聪明的顺溜》第09集：比武大赛",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499324157708_39_1610.mp4",
      },
      {
        column: "10",
        title: "《聪明的顺溜》第10集：危机边缘",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499324221811_39_172.mp4",
      },
      {
        column: "11",
        title: "《聪明的顺溜》第11集：神秘高手",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499324355183_39_149.mp4",
      },
      {
        column: "12",
        title: "《聪明的顺溜》第12集：恐怖的赵娴",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499324436138_39_1945.mp4",
      },
      {
        column: "13",
        title: "《聪明的顺溜》第13集：联手进击",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499324603057_39_1571.mp4",
      },
      {
        column: "14",
        title: "《聪明的顺溜》第14集：第一课",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499324687816_39_1912.mp4",
      },
      {
        column: "15",
        title: "《聪明的顺溜》第15集：地狱周的开始",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499324733799_39_1149.mp4",
      },
      {
        column: "16",
        title: "《聪明的顺溜》第16集：雏鹰展翅",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499324780893_39_1708.mp4",
      },
      {
        column: "17",
        title: "《聪明的顺溜》第17集：空中遇险",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499324831193_39_1650.mp4",
      },
      {
        column: "18",
        title: "《聪明的顺溜》第18集：我是教官",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499324875958_39_1776.mp4",
      },
      {
        column: "19",
        title: "《聪明的顺溜》第19集：特训课",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499324933621_39_1115.mp4",
      },
      {
        column: "20",
        title: "《聪明的顺溜》第20集：地底黑影",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499324985513_39_1535.mp4",
      },
      {
        column: "21",
        title: "《聪明的顺溜》第21集：冲出地穴",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499325031672_39_1256.mp4",
      },
      {
        column: "22",
        title: "《聪明的顺溜》第22集：前进吧！坦克",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499325105391_39_1531.mp4",
      },
      {
        column: "23",
        title: "《聪明的顺溜》第23集：秘密突击",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499325150773_39_1148.mp4",
      },
      {
        column: "24",
        title: "《聪明的顺溜》第24集：蛙人行动",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499325204875_39_1370.mp4",
      },
      {
        column: "25",
        title: "《聪明的顺溜》第25集：第一名",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499325256305_39_1734.mp4",
      },
      {
        column: "26",
        title: "《聪明的顺溜》第26集：孤岛求生",
        url: "http://vskd.bj.bcebos.com//video/2017/7/6/2017761499325305925_39_1197.mp4",
      },
    ],
  },

  {
    title: "BABY驾到",
    desc: "《Baby驾到》是一档以逗趣和搞笑来呈现的育儿百科动画作品。向观众阐述从备孕至宝宝6岁育儿的各类知识。播出的动画内容以当今80、90后新生代适婚人群喜爱的内容为基础，配合丰富有趣的动画情节和设计巧妙的人物属性，力求给观众带来与众不同的观看感受。",
    list: [
      {
        column: "1",
        title: "《BABY驾到》备孕篇第一集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499152248001_39_19.mp4",
      },
      {
        column: "2",
        title: "《BABY驾到》备孕篇第二集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499152397033_39_1762.mp4",
      },
      {
        column: "3",
        title: "《BABY驾到》备孕篇第三集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499152461761_39_1366.mp4",
      },
      {
        column: "4",
        title: "《BABY驾到》备孕篇第四集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499152514410_39_175.mp4",
      },
      {
        column: "5",
        title: "《BABY驾到》备孕篇第五集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499152572436_39_1840.mp4",
      },
      {
        column: "6",
        title: "《BABY驾到》备孕篇第六集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499152640727_39_1564.mp4",
      },
      {
        column: "7",
        title: "《BABY驾到》备孕篇第七集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499152682643_39_1565.mp4",
      },
      {
        column: "8",
        title: "《BABY驾到》备孕篇第八集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499152719600_39_1533.mp4",
      },
      {
        column: "9",
        title: "《BABY驾到》备孕篇第九集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499152756637_39_123.mp4",
      },
      {
        column: "10",
        title: "《BABY驾到》备孕篇第十集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499152790520_39_173.mp4",
      },
      {
        column: "11",
        title: "《BABY驾到》备孕篇第十一集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499152836084_39_1806.mp4",
      },
      {
        column: "12",
        title: "《BABY驾到》备孕篇第十二集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499152883161_39_141.mp4",
      },
      {
        column: "13",
        title: "《BABY驾到》怀孕篇第一集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499153293843_39_1936.mp4",
      },
      {
        column: "14",
        title: "《BABY驾到》怀孕篇第二集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499153332644_39_1818.mp4",
      },
      {
        column: "15",
        title: "《BABY驾到》怀孕篇第三集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499153397453_39_1404.mp4",
      },
      {
        column: "16",
        title: "《BABY驾到》怀孕篇第四集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499153475669_39_1348.mp4",
      },
      {
        column: "17",
        title: "《BABY驾到》怀孕篇第五集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499153439448_39_1413.mp4",
      },
      {
        column: "18",
        title: "《BABY驾到》怀孕篇第六集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499153510021_39_1978.mp4",
      },
      {
        column: "19",
        title: "《BABY驾到》怀孕篇第七集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499153540229_39_1439.mp4",
      },
      {
        column: "20",
        title: "《BABY驾到》怀孕篇第九集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499153597790_39_1174.mp4",
      },
      {
        column: "21",
        title: "《BABY驾到》怀孕篇第十集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499153637874_39_1650.mp4",
      },
      {
        column: "22",
        title: "《BABY驾到》怀孕篇第十一集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499153669459_39_1784.mp4",
      },
      {
        column: "23",
        title: "《BABY驾到》怀孕篇第十二集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499153698484_39_1640.mp4",
      },
      {
        column: "24",
        title: "《BABY驾到》产后护理篇第一集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499153983232_39_1664.mp4",
      },
      {
        column: "25",
        title: "《BABY驾到》产后护理篇第二集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154015770_39_1319.mp4",
      },
      {
        column: "26",
        title: "《BABY驾到》产后护理篇第三集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154039191_39_1305.mp4",
      },
      {
        column: "27",
        title: "《BABY驾到》产后护理篇第四集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154067582_39_1447.mp4",
      },
      {
        column: "28",
        title: "《BABY驾到》产后护理篇第五集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154109869_39_1187.mp4",
      },
      {
        column: "29",
        title: "《BABY驾到》产后护理篇第六集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154144356_39_110.mp4",
      },
      {
        column: "30",
        title: "《BABY驾到》产后护理篇第七集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154173496_39_1689.mp4",
      },
      {
        column: "31",
        title: "《BABY驾到》产后护理篇第八集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154202479_39_1940.mp4",
      },
      {
        column: "32",
        title: "《BABY驾到》产后护理篇第九集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154383434_39_1705.mp4",
      },
      {
        column: "33",
        title: "《BABY驾到》产后护理篇第十集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154414907_39_1731.mp4",
      },
      {
        column: "34",
        title: "《BABY驾到》0-6岁篇第一集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154556047_39_1548.mp4",
      },
      {
        column: "35",
        title: "《BABY驾到》0-6岁篇第二集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154580863_39_1766.mp4",
      },
      {
        column: "36",
        title: "《BABY驾到》0-6岁篇第三集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154614891_39_1115.mp4",
      },
      {
        column: "37",
        title: "《BABY驾到》0-6岁篇第四集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154641678_39_168.mp4",
      },
      {
        column: "38",
        title: "《BABY驾到》0-6岁篇第五集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154664684_39_1320.mp4",
      },
      {
        column: "39",
        title: "《BABY驾到》0-6岁篇第六集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154684256_39_15.mp4",
      },
      {
        column: "40",
        title: "《BABY驾到》0-6岁篇第七集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154704961_39_153.mp4",
      },
      {
        column: "41",
        title: "《BABY驾到》0-6岁篇第八集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154726314_39_1306.mp4",
      },
      {
        column: "42",
        title: "《BABY驾到》0-6岁篇第九集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154745864_39_1449.mp4",
      },
      {
        column: "43",
        title: "《BABY驾到》0-6岁篇第十集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154769744_39_1653.mp4",
      },
      {
        column: "44",
        title: "《BABY驾到》0-6岁篇第十一集",
        url: "http://vskd.bj.bcebos.com//video/2017/7/4/2017741499154793897_39_1191.mp4",
      },
    ],
  },
  {
    title: "千名医师讲中医",
    desc: "国家中医药管理局积极推进以“方便看中医”“放心用中药”行动为重点内容的“我为群众办实事”实践活动，深入开展“千名医师讲中医”活动，传播中医药健康文化，组织中医药专家在主流媒体和平台宣传《中医药健康教育基本内容》和《中国公民中医养生保健素养》等中医药文化理念和养生保健知识。",
    list: [
      {
        column: "1",
        title: "千名医师讲中医-针灸调理亚健康",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634795931167_85_1943.mp4",
      },
      {
        column: "2",
        title: "千名医师讲中医-眩晕的奥秘（古联、谭庆晶）",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796000928_85_1752.mp4",
      },
      {
        column: "3",
        title: "千名医师讲中医-你又失眠了-刘莉",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796001214_85_1116.mp4",
      },
      {
        column: "4",
        title: "千名医师讲中医-不良习惯导致脊椎病-廖炼炼",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796001511_85_1572.mp4",
      },
      {
        column: "5",
        title: "千名医师讲中医-近视防治",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796001830_85_1209.mp4",
      },
      {
        column: "6",
        title: "千名医师讲中医-头痛真让人头痛-覃启京",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796002140_85_1201.mp4",
      },
      {
        column: "7",
        title: "千名医师讲中医-鼻炎又犯了-陆灵娟",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796002467_85_1533.mp4",
      },
      {
        column: "8",
        title: "千名医师讲中医-口臭的防治-谭桂萍",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796002798_85_1450.mp4",
      },
      {
        column: "9",
        title: "千名医师讲中医-宝宝PK流感_中医教您怎样才能赢",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796022322_85_131.mp4",
      },
      {
        column: "10",
        title: "千名医师讲中医-10国人疾病高血压-农甘彤",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796022612_85_1900.mp4",
      },
      {
        column: "11",
        title: "千名医师讲中医-儿童睡眠时间推荐-甘娜",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796022897_85_1772.mp4",
      },
      {
        column: "12",
        title: "千名医师讲中医-风湿病科竹罐疗法",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796023182_85_1347.mp4",
      },
      {
        column: "13",
        title: "千名医师讲中医-流行性感冒-舒莉莉",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796023472_85_1649.mp4",
      },
      {
        column: "14",
        title: "千名医师讲中医-况彦德6药线点灸疗法",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796023764_85_1192.mp4",
      },
      {
        column: "15",
        title: "千名医师讲中医-便秘科普-刘丹",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796024039_85_1827.mp4",
      },
      {
        column: "16",
        title: "千名医师讲中医-恶性肿瘤早期诊断治疗-刘汉峰",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796043797_85_1491.mp4",
      },
      {
        column: "17",
        title: "千名医师讲中医-冠心病-李健",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796044100_85_1355.mp4",
      },
      {
        column: "18",
        title: "千名医师讲中医-动脉硬化是什么-李莲",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796044378_85_1269.mp4",
      },
      {
        column: "19",
        title: "千名医师讲中医-肛肠疾病总论",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796044658_85_1690.mp4",
      },
      {
        column: "20",
        title: "千名医师讲中医-多动症",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796044943_85_1214.mp4",
      },
      {
        column: "21",
        title: "千名医师讲中医-便秘",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796045243_85_1989.mp4",
      },
      {
        column: "22",
        title: "千名医师讲中医-乌鸡补血汤",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796045521_85_1526.mp4",
      },
      {
        column: "23",
        title: "千名医师讲中医-四君猪肚汤",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796082053_85_1981.mp4",
      },
      {
        column: "24",
        title: "千名医师讲中医-紫苏瘦肉粥",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796082352_85_1963.mp4",
      },
      {
        column: "25",
        title: "千名医师讲中医-胃痛",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796082646_85_179.mp4",
      },
      {
        column: "26",
        title: "千名医师讲中医-我近视了吗-巫赢",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796082967_85_1758.mp4",
      },
      {
        column: "27",
        title: "千名医师讲中医-秋冬季节皮肤病-李芳梅",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796083254_85_1760.mp4",
      },
      {
        column: "28",
        title: "千名医师讲中医-生姜当归羊肉汤",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796083555_85_1384.mp4",
      },
      {
        column: "29",
        title: "千名医师讲中医-针灸的起源",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796083852_85_1710.mp4",
      },
      {
        column: "30",
        title: "千名医师讲中医-糖尿病的危害-胡璟",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796107683_85_1353.mp4",
      },
      {
        column: "31",
        title: "千名医师讲中医-外科疾病是如何发生的",
        url: "http://vskd.bj.bcebos.com//video/2021/10/21/202110211634796108001_85_1555.mp4",
      },
      {
        column: "32",
        title: "千名医师讲中医-三伏灸",
        url: "http://vskd.bj.bcebos.com//video/2021/11/11/202111111636611646924_85_156.mp4",
      },
      {
        column: "33",
        title: "千名医师讲中医-口眼歪斜就是中风了吗",
        url: "http://vskd.bj.bcebos.com//video/2021/11/11/202111111636611647279_85_1852.mp4",
      },
      {
        column: "34",
        title: "千名医师讲中医-失眠",
        url: "http://vskd.bj.bcebos.com//video/2021/11/11/202111111636611647596_85_1944.mp4",
      },
      {
        column: "35",
        title: "千名医师讲中医-失眠症",
        url: "http://vskd.bj.bcebos.com//video/2021/11/11/202111111636611647913_85_1773.mp4",
      },
      {
        column: "36",
        title: "千名医师讲中医-寒湿性腰痛怎么办",
        url: "http://vskd.bj.bcebos.com//video/2021/11/11/202111111636611648231_85_1701.mp4",
      },
      {
        column: "37",
        title: "千名医师讲中医-游走罐",
        url: "http://vskd.bj.bcebos.com//video/2021/11/11/202111111636611861501_85_1731.mp4",
      },
      {
        column: "38",
        title: "千名医师讲中医-腰痛病",
        url: "http://vskd.bj.bcebos.com//video/2021/11/11/202111111636611861801_85_1497.mp4",
      },
      {
        column: "39",
        title: "千名医师讲中医-葫芦灸",
        url: "http://vskd.bj.bcebos.com//video/2021/11/11/202111111636611862097_85_1922.mp4",
      },
      {
        column: "40",
        title: "千名医师讲中医-过敏性鼻炎",
        url: "http://vskd.bj.bcebos.com//video/2021/11/11/202111111636611862405_85_1318.mp4",
      },
      {
        column: "41",
        title: "千名医师讲中医-过敏性鼻炎怎么办",
        url: "http://vskd.bj.bcebos.com//video/2021/11/11/202111111636611862705_85_1776.mp4",
      },
    ],
  },
  {
    title: "青少年航天科普教育专家系列录播课",
    desc: "青少年航天科普教育在线培训课程是进行航天科普和青少年航天科技教育的精品课程，为宣传我国航天事业取得的成就、培养青少年的科学精神和探究能力，围绕我国在航天科技领域的重大成果，帮助学校和科技辅导员航天更好地开展航天科普活动，传播航天知识和科学精神，分享青少年航天科普教育经验，加强青少年航天科普活动教师队伍建设，本次线上精品课程邀请多位经验丰富的专家和一线教师结合实践进行专业分享。内容涉及月球系列课程、卫星系列课程、火星系列课程，航天科普活动系列讲座及深空探测发展，揭秘月球环境，解读“月球基地搭建”课程，中国空间站发展历程及空间站搭载科学实验讲解，北斗系统九大领域应用情况解读，如何开展航天科普教育、解读“如何深入开展青少年航天科普教育”、航天类STEM课程的教学设计等丰富内容。",
    list: [
      {
        column: "1",
        title: "青少航天科普课01-中国航天的缘起-钱学森和东方红一号的故事",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265612189_85_1539.mp4",
      },
      {
        column: "2",
        title: "青少航天科普课02-我国人造卫星事业的缘起与发展",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265612502_85_1421.mp4",
      },
      {
        column: "3",
        title: "青少航天科普课03-区域航天科普教育和高校航天人才培养",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265359357_85_1758.mp4",
      },
      {
        column: "4",
        title: "青少航天科普课04-航天员与航天服（上）",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265612834_85_1479.mp4",
      },
      {
        column: "5",
        title: "青少航天科普课05-航天员与航天服（中）",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265613169_85_1732.mp4",
      },
      {
        column: "6",
        title: "青少航天科普课06-航天员与航天服（下）",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265656458_85_1476.mp4",
      },
      {
        column: "7",
        title:
          "青少航天科普课07-青少年航天科普教育实践-以成都华西中学和梁启超纪念中学为例",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265656802_85_1276.mp4",
      },
      {
        column: "8",
        title:
          "青少航天科普课08-人类眼中的月亮和深空探测的月球-月球与深空探测（上）",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265657117_85_1293.mp4",
      },
      {
        column: "9",
        title:
          "青少航天科普课09-人类眼中的月亮和深空探测的月球-月球与深空探测（下）",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265657428_85_1785.mp4",
      },
      {
        column: "10",
        title: "青少航天科普课10-区域航天类STEM教育研究实践",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265657734_85_1604.mp4",
      },
      {
        column: "11",
        title: "青少航天科普课11-火星探测的魅力（上）",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265658033_85_1815.mp4",
      },
      {
        column: "12",
        title: "青少航天科普课12-火星探测的魅力（中）",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265728788_85_1729.mp4",
      },
      {
        column: "13",
        title: "青少航天科普课13-火星探测的魅力（下）",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265729100_85_1379.mp4",
      },
      {
        column: "14",
        title: "青少航天科普课14-航天赋能中小学拔尖创新人才培养",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265729401_85_1888.mp4",
      },
      {
        column: "15",
        title: "青少航天科普课15-铭记历史，传承精神—中国航天和航天精神",
        url: "http://vskd.bj.bcebos.com//video/2021/10/15/202110151634265729695_85_1407.mp4",
      },
    ],
  },
  {
    title: "“贝多芬新声”耳科科普专题",
    desc: "你能想象一个无声的世界吗？中国耳科权威专家联手打造“贝多芬新声”耳科科普专题，将关于耳部健康的一切都讲给你听。",
    list: [
      {
        column: "1",
        title: "《贝多芬新声》耳科科普01咽鼓管视频病例",
        url: "http://vskd.bj.bcebos.com//video/2021/10/9/20211091633764302345_85_1481.mp4",
      },
      {
        column: "2",
        title: "《贝多芬新声》耳科科普02咽鼓管结构特点",
        url: "http://vskd.bj.bcebos.com//video/2021/10/9/20211091633764302648_85_1659.mp4",
      },
      {
        column: "3",
        title: "《贝多芬新声》耳科科普03咽鼓管有哪些功能",
        url: "http://vskd.bj.bcebos.com//video/2021/10/9/20211091633764302908_85_1155.mp4",
      },
      {
        column: "4",
        title: "《贝多芬新声》耳科科普04咽鼓管功能障碍分类",
        url: "http://vskd.bj.bcebos.com//video/2021/10/9/20211091633764303158_85_1653.mp4",
      },
      {
        column: "5",
        title: "《贝多芬新声》耳科科普05咽鼓管功能障碍治疗手段",
        url: "http://vskd.bj.bcebos.com//video/2021/10/9/20211091633764303434_85_1769.mp4",
      },
    ],
  },
  {
    title: "《节水总动员》大众版",
    desc: "谁和我们生命息息相关？谁是我们人类的“老朋友”？答案是：水。千百年来，水伴随着我们生命的起源与成长。有一天，当一颗小水滴变成一个可爱的小精灵，会发生什么样的故事？ 《节水总动员》从一种独特的角度切入，以大自然中的一颗小水滴——水宝为主角，通过讲述他在人类世界中一系列趣味生动的冒险经历，将识水、惜水、节水等知识点巧妙地融入其中，在潜移默化中让观众认识到节水、护水的重要性及必要性。本片由12个与节水先关的动画短片组成，通过寓教于乐的形式，旨在传递一种和谐可持续发展的价值观和节约用水、绿色发展的理念。",
    list: [
      {
        column: "1",
        title: "《节水总动员》大众版01水的家族",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723058782_85_1494.mp4",
      },
      {
        column: "2",
        title: "《节水总动员》大众版02水从哪里来",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723059045_85_1132.mp4",
      },
      {
        column: "3",
        title: "《节水总动员》大众版03水创造的文明",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723059288_85_1157.mp4",
      },
      {
        column: "4",
        title: "《节水总动员》大众版04我们究竟有多少水资源",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723059566_85_1881.mp4",
      },
      {
        column: "5",
        title: "《节水总动员》大众版05危险的水",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723067595_85_1874.mp4",
      },
      {
        column: "6",
        title: "《节水总动员》大众版06自来水怎么进千家万户",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723067841_85_1299.mp4",
      },
      {
        column: "7",
        title: "《节水总动员》大众版07生活中如何节水",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723068099_85_1334.mp4",
      },
      {
        column: "8",
        title: "《节水总动员》大众版08工业如何节水",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723068347_85_1872.mp4",
      },
      {
        column: "9",
        title: "《节水总动员》大众版09农业如何节水",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723068602_85_1699.mp4",
      },
      {
        column: "10",
        title: "《节水总动员》大众版10中水回收利用",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723068866_85_1730.mp4",
      },
      {
        column: "11",
        title: "《节水总动员》大众版11雨水如何利用",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723069115_85_1146.mp4",
      },
      {
        column: "12",
        title: "《节水总动员》大众版12世界各国节水方式",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723075779_85_11.mp4",
      },
    ],
  },
  {
    title: "《节水总动员》青少版",
    desc: "少年时，我们都渴望探险，而水宝君的经历却是如此不同。这不仅是了解水科学知识，而且是掌握节水相关知识和手段的历程。 本片讲述了水家族的成员——水宝君和他的朋友小乌鸦、水女神，在人类世界四处探险时发生的各种趣事。在充满惊喜和欢乐的经历中，水宝君也努力向身边的朋友传递水科学知识以及节约和保护水资源、保护生态环境的理念。 节水护水、动员起来，行动起来！ 普及科学知识，强化节水意识，形成节水习惯，建设节水型社会。",
    list: [
      {
        column: "1",
        title: "《节水总动员》青少版01煮不熟的玉米",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723076041_85_1110.mp4",
      },
      {
        column: "2",
        title: "《节水总动员》青少版02寻找水女神",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723076287_85_1141.mp4",
      },
      {
        column: "3",
        title: "《节水总动员》青少版03迷路的探险家",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723076551_85_138.mp4",
      },
      {
        column: "4",
        title: "《节水总动员》青少版04现代水危机",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723076803_85_1938.mp4",
      },
      {
        column: "5",
        title: "《节水总动员》青少版05水利工程的浪漫",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723077060_85_1184.mp4",
      },
      {
        column: "6",
        title: "《节水总动员》青少版06以水定城",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723077302_85_1850.mp4",
      },
      {
        column: "7",
        title: "《节水总动员》青少版07自来水之旅",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723084403_85_1618.mp4",
      },
      {
        column: "8",
        title: "《节水总动员》青少版08洪水不是猛兽",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723084691_85_1293.mp4",
      },
      {
        column: "9",
        title: "《节水总动员》青少版09重启工厂",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723084958_85_1861.mp4",
      },
      {
        column: "10",
        title: "《节水总动员》青少版10谁偷了我的菜",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723085215_85_185.mp4",
      },
      {
        column: "11",
        title: "《节水总动员》青少版11爱生活的钱老板",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723085474_85_1335.mp4",
      },
      {
        column: "12",
        title: "《节水总动员》青少版12最好的朋友",
        url: "http://vskd.bj.bcebos.com//video/2021/9/27/20219271632723085720_85_110.mp4",
      },
    ],
  },
  {
    title: "2020月亮嘉年华",
    desc: "2020年第三届“月亮嘉年华”，火星伴月球，万里看今朝",
    list: [
      {
        column: "1",
        title: "2020月亮嘉年华：从火星车设计工程师的角度看月球",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620809366153_85_1799.mp4",
      },
      {
        column: "2",
        title: "2020月亮嘉年华：如何区分_哥白尼纪不同的界别”",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620809366455_85_1124.mp4",
      },
      {
        column: "3",
        title: "2020月亮嘉年华：嫦娥1号到4号，带来了哪些关于月球的科研进展",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620809366809_85_1729.mp4",
      },
      {
        column: "4",
        title: "2020月亮嘉年华：想靠月球的资源发财？可能吗？",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620809375828_85_1386.mp4",
      },
      {
        column: "5",
        title: "2020月亮嘉年华：是什么吸引了科学家们开启探月征程？",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620809376252_85_1726.mp4",
      },
      {
        column: "6",
        title: "2020月亮嘉年华：月球存在外星文明的可能性大吗？",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620809376750_85_1933.mp4",
      },
      {
        column: "7",
        title: "2020月亮嘉年华：未来的火星探测目标是什么",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620809377457_85_1725.mp4",
      },
      {
        column: "8",
        title:
          "2020月亮嘉年华：火星上的水是怎么被发现的？能否满足人类移民的生存依赖",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620809378321_85_1971.mp4",
      },
      {
        column: "9",
        title: "2020月亮嘉年华：火星探测的进程",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620809378731_85_1246.mp4",
      },
      {
        column: "10",
        title: "2020月亮嘉年华：玉兔探月车的起伏一生，感动满满",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620809379198_85_1726.mp4",
      },
      {
        column: "11",
        title: "2020月亮嘉年华：科幻作品中的火星元素是如何展现的",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620809390664_85_1770.mp4",
      },
      {
        column: "12",
        title: "2020月亮嘉年华：“月球地貌—哥白尼环形山”鉴证月球历史",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620809365829_85_1800.mp4",
      },
    ],
  },
  {
    title: "幻海寻踪",
    desc: "本系列讲述科幻电影中的硬核科学。",
    list: [
      {
        column: "1",
        title: "幻海寻踪（第1期）丨太空旅行是否可行？",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620810241198_85_1538.mp4",
      },
      {
        column: "2",
        title: "幻海寻踪（第2期）丨科幻电影里的外星生命",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620810205595_85_1282.mp4",
      },
      {
        column: "3",
        title: "幻海寻踪（第3期）丨有关时光旅行的那些事儿",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620810047630_85_1913.mp4",
      },
      {
        column: "4",
        title: "幻海寻踪（第4期）丨恐龙能否重新现世？",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620810047917_85_1382.mp4",
      },
      {
        column: "5",
        title: "幻海寻踪（第5期）丨人工智能的理想与现实？",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620810048196_85_1247.mp4",
      },
      {
        column: "6",
        title: "幻海寻踪（第6期）丨探秘高科技装备的武力值",
        url: "http://vskd.bj.bcebos.com//video/2021/5/12/20215121620810048611_85_1799.mp4",
      },
      {
        column: "7",
        title: "幻海寻踪（第7期）丨气候骤变是否会引发世界末日？",
        url: "http://vskd.bj.bcebos.com//video/2021/8/4/2021841628065087517_85_1318.mp4",
      },
      {
        column: "8",
        title: "幻海寻踪（第8期）丨基因工程能否更好地改变人类生活？",
        url: "http://vskd.bj.bcebos.com//video/2021/8/4/2021841628065365974_85_1809.mp4",
      },
      {
        column: "9",
        title: "幻海寻踪（第9期）丨解读科幻电影中的未来社会",
        url: "http://vskd.bj.bcebos.com//video/2021/8/4/2021841628065203402_85_1761.mp4",
      },
      {
        column: "10",
        title: "幻海寻踪（第10期）丨大数据与人工智能的科学奥义",
        url: "http://vskd.bj.bcebos.com//video/2021/8/4/2021841628065110045_85_1940.mp4",
      },
    ],
  },
  {
    title: "美国科学促进会",
    desc: "美国科学促进会（American Association for the Advancement of Science—AAAS，以下简称科促会）成立于1848年，是世界上最大的科学和工程学协会的联合体，也是最大的非盈利性国际科技组织，下设21个专业分会，涉及的学科包括数学、物理、化学、天文、地理、生物等自然科学和社会科学。",
    list: [
      {
        column: "1",
        title: "被土星“环形雨”影响的电离层特殊现象",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350169663_76_1116.mp4",
      },
      {
        column: "2",
        title: "游隼的超级速度",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350156877_76_146.mp4",
      },
      {
        column: "3",
        title: "简易机器人组队解决复杂问题",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350157177_76_1853.mp4",
      },
      {
        column: "4",
        title: "自动驾驶汽车的社会性困局",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350157479_76_1386.mp4",
      },
      {
        column: "5",
        title: "新发现正颠覆我们对宇宙的认知",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350155959_76_1126.mp4",
      },
      {
        column: "6",
        title: "机器人利用“想象力”学习概念",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350156284_76_1747.mp4",
      },
      {
        column: "7",
        title: "海狸坝离开了海狸还行吗",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350156592_76_1406.mp4",
      },
      {
        column: "8",
        title: "微型机器人穿梭于眼睛中运送药物",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350155655_76_1106.mp4",
      },
      {
        column: "9",
        title: "帕克探测器将探索太阳大气层",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350142081_76_1238.mp4",
      },
      {
        column: "10",
        title: "古代地震与洪水可能孕育了中华文明",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350141021_76_1958.mp4",
      },
      {
        column: "11",
        title: "天文学家正在积极探索地外生命",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350141324_76_1153.mp4",
      },
      {
        column: "12",
        title: "天文学家绘制出银河系星图",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350141675_76_1541.mp4",
      },
      {
        column: "13",
        title: "2018科学界重大突破",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350139915_76_1793.mp4",
      },
      {
        column: "14",
        title: "为什么鲸鱼那么大",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350140374_76_1381.mp4",
      },
      {
        column: "15",
        title: "光线让鸟儿更帅气",
        url: "http://vskd.bj.bcebos.com//video/2019/12/3/20191231575350140720_76_146.mp4",
      },
    ],
  },
  {
    title: "麻省理工学院：K12课程",
    desc: "K12或K-12，是kindergarten through twelfth grade的简写，是指从幼儿园（Kindergarten，通常5-6岁）到十二年级（grade 12，通常17-18岁），这两个年级是美国、澳大利亚及English Canada的免费教育头尾的两个年级，此外也可用作对基 本课程是由来自麻省理工学院的师生制作。网址： http://www.k12videos.mit.edu/",
    list: [
      {
        column: "1",
        title: "麻省理工：K12-借助植物解开生物学奥秘",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347626872_39_1838.mp4",
      },
      {
        column: "2",
        title: "麻省理工：K12-马廊戈尼效应",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347625953_39_1483.mp4",
      },
      {
        column: "3",
        title: "麻省理工：K12-麻省理工物理学演示：线路爆炸与欧姆定律",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347626232_39_1877.mp4",
      },
      {
        column: "4",
        title: "麻省理工：K12-黑暗中的爆破声：在黑暗中声音是如何帮我们看清的",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347626546_39_1890.mp4",
      },
      {
        column: "5",
        title: "麻省理工：K12-食用色素与牛奶",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347625666_39_1774.mp4",
      },
      {
        column: "6",
        title: "麻省理工：K12-量热法简介",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347604926_39_1781.mp4",
      },
      {
        column: "7",
        title: "麻省理工：K12-金星的中心有多热？",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347605211_39_1857.mp4",
      },
      {
        column: "8",
        title: "麻省理工：K12-飞机的受力分析",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347605467_39_1651.mp4",
      },
      {
        column: "9",
        title: "麻省理工：K12-超疏水和超亲水表面",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347604045_39_1985.mp4",
      },
      {
        column: "10",
        title: "麻省理工：K12-跑车的空气动力学",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347604389_39_117.mp4",
      },
      {
        column: "11",
        title: "麻省理工：K12-运动图",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347604652_39_1250.mp4",
      },
      {
        column: "12",
        title: "麻省理工：K12-表面张力",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347603669_39_1353.mp4",
      },
      {
        column: "13",
        title: "麻省理工：K12-节日彩灯：串联还是并联？",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347573832_39_1682.mp4",
      },
      {
        column: "14",
        title: "麻省理工：K12-电路",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347573095_39_1775.mp4",
      },
      {
        column: "15",
        title: "麻省理工：K12-自制熔岩灯",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347573331_39_114.mp4",
      },
      {
        column: "16",
        title: "麻省理工：K12-滑轮很酷",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347571944_39_1864.mp4",
      },
      {
        column: "17",
        title: "麻省理工：K12-火星之旅--太空中的骨头损害",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347572321_39_1680.mp4",
      },
      {
        column: "18",
        title: "麻省理工：K12-火箭科学",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347572589_39_1215.mp4",
      },
      {
        column: "19",
        title: "麻省理工：K12-熵",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347572837_39_1616.mp4",
      },
      {
        column: "20",
        title: "麻省理工：K12-气体中的折射",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347555104_39_1220.mp4",
      },
      {
        column: "21",
        title: "麻省理工：K12-气球的浮力",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347555374_39_1113.mp4",
      },
      {
        column: "22",
        title: "麻省理工：K12-没有摩擦的世界",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347555614_39_1708.mp4",
      },
      {
        column: "23",
        title: "麻省理工：K12-河流清洁整治工程",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347555851_39_1713.mp4",
      },
      {
        column: "24",
        title: "麻省理工：K12-桥梁设计和破坏_第二部分",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347554276_39_1788.mp4",
      },
      {
        column: "25",
        title: "麻省理工：K12-棱镜",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347554560_39_1274.mp4",
      },
      {
        column: "26",
        title: "麻省理工：K12-横梁弯曲-避免失败",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347554848_39_1591.mp4",
      },
      {
        column: "27",
        title: "麻省理工：K12-杨氏双缝实验",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347509902_39_1254.mp4",
      },
      {
        column: "28",
        title: "麻省理工：K12-桥梁的设计和破坏_第一部分",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347510193_39_1202.mp4",
      },
      {
        column: "29",
        title: "麻省理工：K12-怎样使用齿轮去赢下自行车比赛",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347509112_39_1887.mp4",
      },
      {
        column: "30",
        title: "麻省理工：K12-探索电路",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347509354_39_1700.mp4",
      },
      {
        column: "31",
        title: "麻省理工：K12-机器人能有情感吗？",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347509638_39_1434.mp4",
      },
      {
        column: "32",
        title: "麻省理工：K12-影子中的光：泊松点",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347508562_39_1146.mp4",
      },
      {
        column: "33",
        title: "麻省理工：K12-快速地表运动",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347508845_39_1580.mp4",
      },
      {
        column: "34",
        title: "麻省理工：K12-弹性碰撞",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347486834_39_1774.mp4",
      },
      {
        column: "35",
        title: "麻省理工：K12-形状记忆材料",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347487111_39_1353.mp4",
      },
      {
        column: "36",
        title: "麻省理工：K12-多普勒效应",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347485896_39_1832.mp4",
      },
      {
        column: "37",
        title: "麻省理工：K12-弯曲引擎的奥秘",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347486162_39_1844.mp4",
      },
      {
        column: "38",
        title: "麻省理工：K12-弹力的科学（科学大声说第一季第七集）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347486438_39_1623.mp4",
      },
      {
        column: "39",
        title: "麻省理工：K12-均衡的改变",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347485301_39_1127.mp4",
      },
      {
        column: "40",
        title: "麻省理工：K12-声音的形状",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347485602_39_122.mp4",
      },
      {
        column: "41",
        title: "麻省理工：K12-圆周运动背后的数学",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347464136_39_1664.mp4",
      },
      {
        column: "42",
        title: "麻省理工：K12-单轮脚踏车的物理学",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347462992_39_1701.mp4",
      },
      {
        column: "43",
        title: "麻省理工：K12-向麻省理工提问_未来核能是什么样子？",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347463273_39_1107.mp4",
      },
      {
        column: "44",
        title: "麻省理工：K12-四旋翼",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347463582_39_1347.mp4",
      },
      {
        column: "45",
        title: "麻省理工：K12-圆周运动",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347463837_39_1884.mp4",
      },
      {
        column: "46",
        title: "麻省理工：K12-信息的无线传播",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347462370_39_1148.mp4",
      },
      {
        column: "47",
        title: "麻省理工：K12-冰淇淋中的_奥斯特瓦尔德熟化",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347462680_39_1759.mp4",
      },
      {
        column: "48",
        title: "麻省理工：K12-二楼的重力",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347408949_39_1201.mp4",
      },
      {
        column: "49",
        title: "麻省理工：K12-二维平衡——平衡游戏",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347409213_39_196.mp4",
      },
      {
        column: "50",
        title: "麻省理工：K12-亚里斯多德vs伽利略（亚里士多德vs伽利略）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502353534042_39_1546.mp4",
      },
      {
        column: "51",
        title: "麻省理工：K12-上浮下沉：一条傻鱼",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347408101_39_1141.mp4",
      },
      {
        column: "52",
        title: "麻省理工：K12-与布兰卡和艾米尼奥学习科学",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347408418_39_1798.mp4",
      },
      {
        column: "53",
        title: "麻省理工：K12-串并联电路：水的类比",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347408672_39_1144.mp4",
      },
      {
        column: "54",
        title: "麻省理工：K12-3D眼镜的原理",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502347407820_39_1104.mp4",
      },
      {
        column: "55",
        title: "麻省理工：K12-麻省理工为你诠释：如何制作一个电子游戏",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782160137_39_1200.mp4",
      },
      {
        column: "56",
        title: "麻省理工：K12-重力作用于每个人（蜗牛的生活1）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782130986_39_1789.mp4",
      },
      {
        column: "57",
        title: "麻省理工：K12-面包霉杀死细胞",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782131383_39_1800.mp4",
      },
      {
        column: "58",
        title: "麻省理工：K12-飞机和汽车的燃油量",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782131635_39_1946.mp4",
      },
      {
        column: "59",
        title: "麻省理工：K12-身小力量大：平方立方法则",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782129974_39_1949.mp4",
      },
      {
        column: "60",
        title: "麻省理工：K12-达尔文：老鼠和挑剔的孔雀",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782130240_39_1521.mp4",
      },
      {
        column: "61",
        title: "麻省理工：K12-这真的是金的吗？阿基米德和密度",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782130501_39_1250.mp4",
      },
      {
        column: "62",
        title: "麻省理工：K12-酸和碱的颜色化学",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782130743_39_1377.mp4",
      },
      {
        column: "63",
        title: "麻省理工：K12-让麻省理工选择：你自己的化学冒险",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782106024_39_1387.mp4",
      },
      {
        column: "64",
        title: "麻省理工：K12-肥皂",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782104974_39_1816.mp4",
      },
      {
        column: "65",
        title: "麻省理工：K12-胶体（凝絮）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782105259_39_1877.mp4",
      },
      {
        column: "66",
        title: "麻省理工：K12-能通过DNA改造培育出独角兽吗？",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782105503_39_13.mp4",
      },
      {
        column: "67",
        title: "麻省理工：K12-结晶紫的脱色",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782104418_39_1112.mp4",
      },
      {
        column: "68",
        title: "麻省理工：K12-肝脏为什么能再生（而肢体不能）？",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782104718_39_1140.mp4",
      },
      {
        column: "69",
        title: "麻省理工：K12-磁场的吸引力",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782085853_39_1484.mp4",
      },
      {
        column: "70",
        title: "麻省理工：K12-神奇的渗透作用",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782086143_39_135.mp4",
      },
      {
        column: "71",
        title: "麻省理工：K12-类人机器人大脑（《大声讲科学》第一季第二集）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782086417_39_1407.mp4",
      },
      {
        column: "72",
        title: "麻省理工：K12-物质的构成——原子和分子",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782084991_39_1658.mp4",
      },
      {
        column: "73",
        title: "麻省理工：K12-生物塑料",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782085261_39_1445.mp4",
      },
      {
        column: "74",
        title: "麻省理工：K12-电池的发明",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782085555_39_170.mp4",
      },
      {
        column: "75",
        title: "麻省理工：K12-焊接类",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782084692_39_186.mp4",
      },
      {
        column: "76",
        title: "麻省理工：K12-浮力",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782062958_39_192.mp4",
      },
      {
        column: "77",
        title: "麻省理工：K12-溶解氧",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782063320_39_1947.mp4",
      },
      {
        column: "78",
        title: "麻省理工：K12-火+沙=玻璃！",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782063641_39_1300.mp4",
      },
      {
        column: "79",
        title: "麻省理工：K12-星星为什么会闪烁和移动？",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782061970_39_1278.mp4",
      },
      {
        column: "80",
        title: "麻省理工：K12-欧几里得的棒球场",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782062267_39_1385.mp4",
      },
      {
        column: "81",
        title: "麻省理工：K12-流体动力学：非牛顿流体",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782062590_39_1864.mp4",
      },
      {
        column: "82",
        title: "麻省理工：K12-支撑运动是如何做到的？",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782061609_39_1396.mp4",
      },
      {
        column: "83",
        title: "麻省理工：K12-工程设计：变废为宝（科学大声说_第二季第四集）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781944025_39_1120.mp4",
      },
      {
        column: "84",
        title: "麻省理工：K12-我们可以通过改造不需要氧气进行呼吸吗？",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781944282_39_1821.mp4",
      },
      {
        column: "85",
        title: "麻省理工：K12-我是一片叶子：树叶叶绿素层析法",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781944562_39_1513.mp4",
      },
      {
        column: "86",
        title: "麻省理工：K12-计算机如何计算（《大声讲科学》第二季第五集）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502782105750_39_1558.mp4",
      },
      {
        column: "87",
        title: "麻省理工：K12-太阳能电池发电",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781942994_39_1586.mp4",
      },
      {
        column: "88",
        title: "麻省理工：K12-如何制作鼻涕状物质（为何它看起来以假乱真）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781943284_39_1273.mp4",
      },
      {
        column: "89",
        title: "麻省理工：K12-如何自己制作电路",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781943526_39_1543.mp4",
      },
      {
        column: "90",
        title: "麻省理工：K12-岩石循环",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781943775_39_1386.mp4",
      },
      {
        column: "91",
        title: "麻省理工：K12-埃拉托色尼测量地球周长",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781924991_39_1560.mp4",
      },
      {
        column: "92",
        title: "麻省理工：K12-大脑的基本区域",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781925252_39_1955.mp4",
      },
      {
        column: "93",
        title: "麻省理工：K12-太空：这么近，那么远",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781925569_39_1420.mp4",
      },
      {
        column: "94",
        title: "麻省理工：K12-在轨道上漂浮（蜗牛的生活2）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781924451_39_1272.mp4",
      },
      {
        column: "95",
        title: "麻省理工：K12-地球的转动",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781924730_39_1296.mp4",
      },
      {
        column: "96",
        title: "麻省理工：K12-化学发光：光的化学",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781923856_39_1934.mp4",
      },
      {
        column: "97",
        title: "麻省理工：K12-半导体为何物",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781924183_39_1427.mp4",
      },
      {
        column: "98",
        title: "麻省理工：K12-制造：从手工到机械",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781900564_39_1982.mp4",
      },
      {
        column: "99",
        title: "麻省理工：K12-分形的趣味",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781899195_39_1308.mp4",
      },
      {
        column: "100",
        title: "麻省理工：K12-凝胶电泳",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781897833_39_1798.mp4",
      },
      {
        column: "101",
        title: "麻省理工：K12-充分利用太阳能",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781896482_39_121.mp4",
      },
      {
        column: "102",
        title: "麻省理工：K12-像素工程学：长曝光摄影",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781895203_39_1876.mp4",
      },
      {
        column: "103",
        title: "麻省理工：K12-倾斜的地球2--午夜艳阳之地",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781894033_39_1414.mp4",
      },
      {
        column: "104",
        title: "麻省理工：K12-倾斜的地球1--季节的缘由",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781893409_39_1315.mp4",
      },
      {
        column: "105",
        title: "麻省理工：K12-二氧化碳和温室效应",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781874971_39_1185.mp4",
      },
      {
        column: "106",
        title: "麻省理工：K12-为什么我们会流鼻涕？（麻省理工学院讲解）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781873944_39_1239.mp4",
      },
      {
        column: "107",
        title: "麻省理工：K12-为什么气态巨行星是球形的？",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781874271_39_1152.mp4",
      },
      {
        column: "108",
        title: "麻省理工：K12-为何我们会放屁（科学大声说第二季第三集）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781874561_39_1944.mp4",
      },
      {
        column: "109",
        title: "麻省理工：K12-Arduino（一种开源电子平台）教程1",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781873025_39_194.mp4",
      },
      {
        column: "110",
        title: "麻省理工：K12-三只小猪：河边筑屋",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781873312_39_1476.mp4",
      },
      {
        column: "111",
        title: "麻省理工：K12-为什么我们不能使用所有的脑细胞？",
        url: "http://vskd.bj.bcebos.com//video/2017/8/15/20178151502781873681_39_1135.mp4",
      },
      {
        column: "112",
        title: "麻省理工：K12-种子",
        url: "http://vskd.bj.bcebos.com//video/2017/9/4/2017941504486508569_39_1488.mp4",
      },
      {
        column: "113",
        title: "麻省理工：K12-疫苗的作用机制",
        url: "http://vskd.bj.bcebos.com//video/2017/9/4/2017941504486494942_39_141.mp4",
      },
      {
        column: "114",
        title: "麻省理工：K12-神奇的渗透作用",
        url: "http://vskd.bj.bcebos.com//video/2017/9/4/2017941504486495227_39_167.mp4",
      },
      {
        column: "115",
        title: "麻省理工：K12-基因工程",
        url: "http://vskd.bj.bcebos.com//video/2017/9/4/2017941504486494148_39_1261.mp4",
      },
      {
        column: "116",
        title: "麻省理工：K12-心脏的工作机理",
        url: "http://vskd.bj.bcebos.com//video/2017/9/4/2017941504486494415_39_1649.mp4",
      },
      {
        column: "117",
        title: "麻省理工：K12-我们能长出翅膀飞翔吗？",
        url: "http://vskd.bj.bcebos.com//video/2017/9/4/2017941504486494679_39_1809.mp4",
      },
      {
        column: "118",
        title: "麻省理工：K12-船只为何可以漂浮在水面",
        url: "http://vskd.bj.bcebos.com//video/2017/9/4/2017941504486493475_39_1923.mp4",
      },
      {
        column: "119",
        title: "麻省理工：K12-内稳态",
        url: "http://vskd.bj.bcebos.com//video/2017/9/4/2017941504486493820_39_1474.mp4",
      },
      {
        column: "120",
        title: "麻省理工：K12-PCR聚合酶链式反应",
        url: "http://vskd.bj.bcebos.com//video/2017/9/4/2017941504486479874_39_1769.mp4",
      },
    ],
  },
  {
    title: "牛津大学：正确面对艾滋病",
    desc: '"牛津大学（University of Oxford），简称“牛津”，位于英国牛津市，是一所誉满全球的世界顶级研究型书院联邦制大学，与剑桥大学并称牛剑，与剑桥大学、伦敦大学学院、帝国理工学院、伦敦政治经济学院同属“G5超级精英大学” 牛津大学纳菲尔德学医学院致力于HIV病毒及其疫苗研究的学者接受系列访谈，介绍了HIV病毒研究和临床医学的现状，总结了过去十年来该领域取得的重大进展，展望了未来HIV疫苗研制和新疗法的发展前景。 讲师：安德鲁·麦克迈克尔 简介：韦瑟罗尔分子医学学院临床医学部负责人 视频来自牛津大学公开课http://podcasts.ox.ac.uk/ 支持CC知识共享协议BY-NC-SA 2.0 英国 https://creativecommons.org/licenses/by-nc-sa/2.0/uk/',
    list: [
      {
        column: "1",
        title: "牛津大学：艾滋病-1我们能否根除HIV",
        url: "http://vskd.bj.bcebos.com//video/2017/10/9/20171091507528824938_39_1846.mp4",
      },
      {
        column: "2",
        title: "牛津大学：艾滋病-2HIV疫苗研制",
        url: "http://vskd.bj.bcebos.com//video/2017/10/9/20171091507528826083_39_1669.mp4",
      },
      {
        column: "3",
        title: "牛津大学：艾滋病-3HIV与非洲儿童",
        url: "http://vskd.bj.bcebos.com//video/2017/10/9/20171091507528827365_39_1810.mp4",
      },
      {
        column: "4",
        title: "牛津大学：艾滋病-4我们如何与HIV共存",
        url: "http://vskd.bj.bcebos.com//video/2017/10/9/20171091507528828408_39_1393.mp4",
      },
      {
        column: "5",
        title: "牛津大学：艾滋病-5HIV疫苗的免疫",
        url: "http://vskd.bj.bcebos.com//video/2017/10/9/20171091507528829700_39_1404.mp4",
      },
      {
        column: "6",
        title: "牛津大学：艾滋病-6HIV疫苗的制作标准",
        url: "http://vskd.bj.bcebos.com//video/2017/10/9/20171091507528830981_39_1162.mp4",
      },
    ],
  },
  {
    title: "美国航天宇航局（NASA）",
    desc: "美国国家航空航天局（NASA /ˈnæsə/），是美国联邦政府的一个行政性科研机构，负责制定、实施美国的民用太空计划与开展航空科学暨太空科学的研究。",
    list: [
      {
        column: "1",
        title: "NASA：远征队51-52_发射升空_前往国际空间站",
        url: "http://vskd.bj.bcebos.com//video/2017/8/16/20178161502853483936_39_127.mp4",
      },
      {
        column: "2",
        title: "NASA：黑寡妇脉冲星消耗她的伴侣",
        url: "http://vskd.bj.bcebos.com//video/2017/8/16/20178161502853484212_39_1650.mp4",
      },
      {
        column: "3",
        title: "NASA：美宇航局成员接受媒体采访谈太空生活",
        url: "http://vskd.bj.bcebos.com//video/2017/8/16/20178161502853483001_39_1855.mp4",
      },
      {
        column: "4",
        title: "NASA：远征51乘员移交空间站给远征52",
        url: "http://vskd.bj.bcebos.com//video/2017/8/16/20178161502853483304_39_140.mp4",
      },
      {
        column: "5",
        title: "NASA：远征51乘员组离开空间站",
        url: "http://vskd.bj.bcebos.com//video/2017/8/16/20178161502853483630_39_1138.mp4",
      },
      {
        column: "6",
        title: "NASA：美国国家航空航天局_特拉普派一号_已知行星中的宝藏",
        url: "http://vskd.bj.bcebos.com//video/2017/8/16/20178161502853482355_39_1467.mp4",
      },
      {
        column: "7",
        title: "NASA：美宇航局成员与母校校友谈太空生活",
        url: "http://vskd.bj.bcebos.com//video/2017/8/16/20178161502853482696_39_1288.mp4",
      },
      {
        column: "8",
        title: "NASA：太空站工作人员与马里兰州学生讨论太空生活",
        url: "http://vskd.bj.bcebos.com//video/2017/8/16/20178161502853456942_39_1933.mp4",
      },
      {
        column: "9",
        title: "NASA：总统特朗普贺电宇航员刷新记录",
        url: "http://vskd.bj.bcebos.com//video/2017/8/16/20178161502853457258_39_1678.mp4",
      },
      {
        column: "10",
        title: "NASA：美国商用飞船抵达太空站",
        url: "http://vskd.bj.bcebos.com//video/2017/8/16/20178161502853457611_39_128.mp4",
      },
      {
        column: "11",
        title: "NASA：一种闪烁的X射线微光",
        url: "http://vskd.bj.bcebos.com//video/2017/8/16/20178161502853455922_39_1542.mp4",
      },
      {
        column: "12",
        title: "NASA：俄罗斯无人驾驶货运飞船出发前往国际空间站",
        url: "http://vskd.bj.bcebos.com//video/2017/8/16/20178161502853456230_39_1215.mp4",
      },
      {
        column: "13",
        title: "NASA：具有观测星系超能力的哈勃望远镜",
        url: "http://vskd.bj.bcebos.com//video/2017/8/16/20178161502853456524_39_1799.mp4",
      },
      {
        column: "14",
        title: "NASA：“远征队”50-51机组人员于“星城”参加最后训练",
        url: "http://vskd.bj.bcebos.com//video/2017/8/16/20178161502853455644_39_1987.mp4",
      },
      {
        column: "15",
        title: "NASA：美国宇航局与赛斯格林",
        url: "http://vskd.bj.bcebos.com//video/2017/8/17/20178171502945345635_39_1980.mp4",
      },
      {
        column: "16",
        title: "NASA：洛克哈特的称赞",
        url: "http://vskd.bj.bcebos.com//video/2017/8/17/20178171502945369842_39_1513.mp4",
      },
      {
        column: "17",
        title: "NASA：韦顿美国宇航局的步骤",
        url: "http://vskd.bj.bcebos.com//video/2017/8/17/20178171502945384643_39_1272.mp4",
      },
    ],
  },
  {
    title: "NASA：科学之光",
    desc: "NASA:美国国家航空航天局（英语-National Aeronautics and Space Administration，简称NASA）是NASA:美国联邦政府的一个行政机构，负责制定、实施NASA:美国的民用太空计划、与开展航空科学暨太空科学的研究。1958年7月29日，NASA:美国总统艾森豪威尔签署了《NASA:美国公共法案85-568》（United States Public Law 85-568，即《NASA:美国国家航空暨太空法案》），创立了NASA，取代了其前身NACA。于1958年10月开始运转。自此，NASA:美国国家航空航天局负责了NASA:美国的太空探索，例如登月的阿波罗计划，太空实验室，以及随后的航天飞机。自2006年2月，NASA:美国国家航空航天局的愿景是 “开拓未来的太空探索，科学发现及航空研究”。NASA:美国国家航空航天局的使命是“理解并保护我们赖以生存的行星；探索宇宙，找到地球外的生命；启示我们的下一代去探索宇宙”。 视频来自 https://nasa.gov/",
    list: [
      {
        column: "1",
        title: "NASA：科学之光-NASA的探空火箭",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355940918_39_1716.mp4",
      },
      {
        column: "2",
        title: "NASA：科学之光-你······在太空中的免疫系统",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355941219_39_1859.mp4",
      },
      {
        column: "3",
        title: "NASA：科学之光-格陵兰正在变薄的冰层",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355941550_39_161.mp4",
      },
      {
        column: "4",
        title: "NASA：科学之光-让飓风季节不构成突袭事件",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355940645_39_1558.mp4",
      },
      {
        column: "5",
        title: "NASA：科学之光-ISS上的天才级材料",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355918001_39_1887.mp4",
      },
      {
        column: "6",
        title: "NASA：科学之光-在11月18日到19日两颗彗星飞过水星",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355918332_39_1459.mp4",
      },
      {
        column: "7",
        title: "NASA：科学之光-火星发生了什么-行星的奥秘",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502414972932_39_1968.mp4",
      },
      {
        column: "8",
        title: "NASA：科学之光-铁青色云体在南极洲上空出现",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355916995_39_1175.mp4",
      },
      {
        column: "9",
        title: "NASA：科学之光-黎明时分双子座流星雨",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355917404_39_1439.mp4",
      },
      {
        column: "10",
        title: "NASA：科学之光-岩石彗星长出一根尾巴",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355917697_39_1532.mp4",
      },
      {
        column: "11",
        title: "NASA：科学之光-水中生火",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355916571_39_198.mp4",
      },
      {
        column: "12",
        title: "NASA：科学之光-突增",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355899012_39_1428.mp4",
      },
      {
        column: "13",
        title: "NASA：科学之光-_以水为尊",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355899244_39_1515.mp4",
      },
      {
        column: "14",
        title: "NASA：科学之光-日冕加热的奥秘",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355899551_39_1828.mp4",
      },
      {
        column: "15",
        title: "NASA：科学之光-_新年的小行星撞击",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355899796_39_175.mp4",
      },
      {
        column: "16",
        title: "NASA：科学之光-与火星对立",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355898074_39_1396.mp4",
      },
      {
        column: "17",
        title: "NASA：科学之光-月食四元组",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355898443_39_1835.mp4",
      },
      {
        column: "18",
        title: "NASA：科学之光-大于星系的望远镜",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355898739_39_1194.mp4",
      },
      {
        column: "19",
        title: "NASA：科学之光-卡林顿级CME（日冕物质抛射）险些碰上地球",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355881096_39_130.mp4",
      },
      {
        column: "20",
        title: "NASA：科学之光-夜光云内未曾预料的遥相关",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355881428_39_1932.mp4",
      },
      {
        column: "21",
        title: "NASA：科学之光-超级月亮之夏",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355879939_39_1514.mp4",
      },
      {
        column: "22",
        title: "NASA：科学之光-来自太空的激光信号",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355880192_39_1344.mp4",
      },
      {
        column: "23",
        title: "NASA：科学之光-罗塞塔彗星复活",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355880430_39_1400.mp4",
      },
      {
        column: "24",
        title: "NASA：科学之光-银河系不仅仅是冰箱磁铁",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355880752_39_1804.mp4",
      },
      {
        column: "25",
        title: "NASA：科学之光-一年飞去冥王星",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355879632_39_1828.mp4",
      },
      {
        column: "26",
        title: "NASA：科学之光-来自于碎裂彗星的新年烟花",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355845327_39_1119.mp4",
      },
      {
        column: "27",
        title: "NASA：科学之光-安太新视野",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355863863_39_1355.mp4",
      },
      {
        column: "28",
        title: "NASA：科学之光-北极海冰扑朔迷离的未来",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355845577_39_1217.mp4",
      },
      {
        column: "29",
        title: "NASA：科学之光-英仙座流星和超级月亮",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355864127_39_1169.mp4",
      },
      {
        column: "30",
        title: "NASA：科学之光-地球附近存在过超新星的证据",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355863087_39_1663.mp4",
      },
      {
        column: "31",
        title: "NASA：科学之光-精确测量系外行星",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355863356_39_1594.mp4",
      },
      {
        column: "32",
        title: "NASA：科学之光-美丽合点",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355863629_39_1559.mp4",
      },
      {
        column: "33",
        title: "NASA：科学之光-地球众人造卫星中的一个巨人",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355862464_39_1821.mp4",
      },
      {
        column: "34",
        title: "NASA：科学之光-臭氧层中的秘密",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355862847_39_1543.mp4",
      },
      {
        column: "35",
        title: "NASA：科学之光-来自MAVEN的第一缕光",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355845887_39_1506.mp4",
      },
      {
        column: "36",
        title: "NASA：科学之光-气候变化与极地海冰的消长",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355845085_39_1670.mp4",
      },
      {
        column: "37",
        title: "NASA：科学之光-_降低阿尔茨海默症（老年痴呆）的罹患率",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355844108_39_1947.mp4",
      },
      {
        column: "38",
        title: "NASA：科学之光-泥物质",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355844434_39_1583.mp4",
      },
      {
        column: "39",
        title: "NASA：科学之光-来自一颗石质彗星的灰烬-2014年双子座流星雨",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355844734_39_1485.mp4",
      },
      {
        column: "40",
        title: "NASA：科学之光-神秘的纳米耀斑",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355822103_39_1441.mp4",
      },
      {
        column: "41",
        title: "NASA：科学之光-地球日流星雨",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355820900_39_1455.mp4",
      },
      {
        column: "42",
        title: "NASA：科学之光-公民科学家发现太空里有黄色球体",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355821185_39_1429.mp4",
      },
      {
        column: "43",
        title: "NASA：科学之光-月全食",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355821451_39_1549.mp4",
      },
      {
        column: "44",
        title: "NASA：科学之光-南半球日食",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355821727_39_191.mp4",
      },
      {
        column: "45",
        title: "NASA：科学之光-宇宙飞船发现数千颗命定彗星",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355820237_39_1550.mp4",
      },
      {
        column: "46",
        title: "NASA：科学之光-丰收之月的月全食",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355820562_39_1771.mp4",
      },
      {
        column: "47",
        title: "NASA：科学之光-寻找地球…2.0",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355798119_39_1693.mp4",
      },
      {
        column: "48",
        title: "NASA：科学之光-黎明行星三角",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355798354_39_1967.mp4",
      },
      {
        column: "49",
        title: "NASA：科学之光-聆听恒星",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355797010_39_1697.mp4",
      },
      {
        column: "50",
        title: "NASA：科学之光-海平面高度的测量",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355797251_39_1857.mp4",
      },
      {
        column: "51",
        title: "NASA：科学之光-蓝色星球归来",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355797537_39_1885.mp4",
      },
      {
        column: "52",
        title: "NASA：科学之光-破坏性电子逃逸",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355797841_39_1418.mp4",
      },
      {
        column: "53",
        title: "NASA：科学之光-印尼日食",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355796702_39_1974.mp4",
      },
      {
        column: "54",
        title: "NASA：科学之光-神奇的卫星",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355779914_39_1635.mp4",
      },
      {
        column: "55",
        title: "NASA：科学之光-空气质量监测",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355779159_39_1569.mp4",
      },
      {
        column: "56",
        title: "NASA：科学之光-冲日的红色和黄色行星",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355779554_39_1229.mp4",
      },
      {
        column: "57",
        title: "NASA：科学之光-木星冲日",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355777982_39_1255.mp4",
      },
      {
        column: "58",
        title: "NASA：科学之光-卫星防御",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355778530_39_1343.mp4",
      },
      {
        column: "59",
        title: "NASA：科学之光-全球风力测量新角度",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355776796_39_1838.mp4",
      },
      {
        column: "60",
        title: "NASA：科学之光-全球变暖热量重组",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355777348_39_1577.mp4",
      },
      {
        column: "61",
        title: "NASA：科学之光-铁青色日落",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355761023_39_136.mp4",
      },
      {
        column: "62",
        title: "NASA：科学之光-造访贝努小行星再返回",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355760061_39_1422.mp4",
      },
      {
        column: "63",
        title: "NASA：科学之光-金星和木星的壮观合点",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355760379_39_1577.mp4",
      },
      {
        column: "64",
        title: "NASA：科学之光-黑暗闪电",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355758982_39_1775.mp4",
      },
      {
        column: "65",
        title: "NASA：科学之光-圣诞节天空秀",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355759359_39_1526.mp4",
      },
      {
        column: "66",
        title: "NASA：科学之光-世界中的世界",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355759650_39_1547.mp4",
      },
      {
        column: "67",
        title: "NASA：科学之光-NASA宇宙飞船以创纪录编队飞行",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355758660_39_1200.mp4",
      },
      {
        column: "68",
        title: "NASA：科学之光-夜光云的一次早到",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355740985_39_1406.mp4",
      },
      {
        column: "69",
        title: "NASA：科学之光-碰撞银河系的云",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355741387_39_1116.mp4",
      },
      {
        column: "70",
        title: "NASA：科学之光-泰坦星（土卫六）波澜不兴之谜",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355739928_39_1721.mp4",
      },
      {
        column: "71",
        title: "NASA：科学之光-机会号的奇异周年庆",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355740245_39_1401.mp4",
      },
      {
        column: "72",
        title: "NASA：科学之光-北极永冻地层中“沉睡的巨人”",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355740563_39_174.mp4",
      },
      {
        column: "73",
        title: "NASA：科学之光-英仙座大流星",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355739317_39_1323.mp4",
      },
      {
        column: "74",
        title: "NASA：科学之光-2016年末有3次超级月亮",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355739605_39_1417.mp4",
      },
      {
        column: "75",
        title: "NASA：科学之光-国际空间站_Firestation”探测仪探索雷暴之巅",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355724934_39_1857.mp4",
      },
      {
        column: "76",
        title: "NASA：科学之光-NASA美国宇航局的使命-寻找月球空气",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355725337_39_1504.mp4",
      },
      {
        column: "77",
        title: "NASA：科学之光-热木星奇特的吸引力",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355725751_39_1362.mp4",
      },
      {
        column: "78",
        title: "NASA：科学之光-业余天文学家看到彗星艾桑靠近太阳",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355724075_39_1546.mp4",
      },
      {
        column: "79",
        title: "NASA：科学之光-收获月",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355724341_39_1441.mp4",
      },
      {
        column: "80",
        title: "NASA：科学之光-星际空间的声音",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355723326_39_1359.mp4",
      },
      {
        column: "81",
        title: "NASA：科学之光-太空气象对航空的影响",
        url: "http://vskd.bj.bcebos.com//video/2017/8/10/20178101502355723677_39_1141.mp4",
      },
      {
        column: "82",
        title: "NASA：科学之光-落日时发生的日食",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543330140_39_1779.mp4",
      },
      {
        column: "83",
        title: "NASA：科学之光-遭遇木星",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543330418_39_1996.mp4",
      },
      {
        column: "84",
        title: "NASA：科学之光-日落时分的粉色行星",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543314901_39_1150.mp4",
      },
      {
        column: "85",
        title: "NASA：科学之光-格陵兰岛的隐藏融化",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543315183_39_1583.mp4",
      },
      {
        column: "86",
        title: "NASA：科学之光-神奇的夜空秀场",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543315418_39_1677.mp4",
      },
      {
        column: "87",
        title: "NASA：科学之光-英仙座流星雨好年",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543315663_39_1769.mp4",
      },
      {
        column: "88",
        title: "NASA：科学之光-拥抱小卫星",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543314071_39_1242.mp4",
      },
      {
        column: "89",
        title: "NASA：科学之光-掠过地球的大块头小行星",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543314349_39_141.mp4",
      },
      {
        column: "90",
        title: "NASA：科学之光-日落时分的三角形",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543314614_39_1423.mp4",
      },
      {
        column: "91",
        title: "NASA：科学之光-太阳磁场即将发生逆转",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543297904_39_169.mp4",
      },
      {
        column: "92",
        title: "NASA：科学之光-宇宙飞船将GPS带到新高度",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543298209_39_144.mp4",
      },
      {
        column: "93",
        title: "NASA：科学之光-彗星ISON飞越火星",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543298482_39_1988.mp4",
      },
      {
        column: "94",
        title: "NASA：科学之光-大漠风沙哺育亚马逊森林",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543297035_39_1349.mp4",
      },
      {
        column: "95",
        title: "NASA：科学之光-太空中闪烁的GPS",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543297342_39_1650.mp4",
      },
      {
        column: "96",
        title: "NASA：科学之光-太阳周期的最新消息-太阳周期峰值也可能是双峰",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543297610_39_1263.mp4",
      },
      {
        column: "97",
        title: "NASA：科学之光-夏季蓝月亮",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543296685_39_1915.mp4",
      },
      {
        column: "98",
        title: "NASA：科学之光-国际空间站上在黑暗中发光的植物",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543281074_39_1717.mp4",
      },
      {
        column: "99",
        title: "NASA：科学之光-国际空间站上的奇怪火焰",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543281429_39_1874.mp4",
      },
      {
        column: "100",
        title: "NASA：科学之光-地球的特殊成分",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543281761_39_1678.mp4",
      },
      {
        column: "101",
        title: "NASA：科学之光-不要让这种事情发生在你的星球上",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543279950_39_19.mp4",
      },
      {
        column: "102",
        title: "NASA：科学之光-从空间站观察地球",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543280221_39_168.mp4",
      },
      {
        column: "103",
        title: "NASA：科学之光-俄罗斯上空爆炸的是什么？",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543280496_39_1587.mp4",
      },
      {
        column: "104",
        title: "NASA：科学之光-光之力量",
        url: "http://vskd.bj.bcebos.com//video/2017/8/24/20178241503543280804_39_1566.mp4",
      },
    ],
  },
  {
    title: "NASA：美国宇航局的地球时刻",
    desc: "NASA:美国国家航空航天局（英语-National Aeronautics and Space Administration，简称NASA）是NASA:美国联邦政府的一个行政机构，负责制定、实施NASA:美国的民用太空计划、与开展航空科学暨太空科学的研究。1958年7月29日，NASA:美国总统艾森豪威尔签署了《NASA:美国公共法案85-568》（United States Public Law 85-568，即《NASA:美国国家航空暨太空法案》），创立了NASA，取代了其前身NACA。于1958年10月开始运转。自此，NASA:美国国家航空航天局负责了NASA:美国的太空探索，例如登月的阿波罗计划，太空实验室，以及随后的航天飞机。自2006年2月，NASA:美国国家航空航天局的愿景是 “开拓未来的太空探索，科学发现及航空研究”。NASA:美国国家航空航天局的使命是“理解并保护我们赖以生存的行星；探索宇宙，找到地球外的生命；启示我们的下一代去探索宇宙”。 视频来自 https://nasa.gov/",
    list: [
      {
        column: "1",
        title: "NASA：美国宇航局的地球时刻-随风飘荡",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502416705950_39_1509.mp4",
      },
      {
        column: "2",
        title: "NASA：美国宇航局的地球时刻-泥土的揭秘",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502416704862_39_1709.mp4",
      },
      {
        column: "3",
        title: "NASA：美国宇航局的地球时刻-海平面上升",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502416705233_39_1328.mp4",
      },
      {
        column: "4",
        title: "NASA：美国宇航局的地球时刻-空中测量仪",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502416705674_39_1341.mp4",
      },
      {
        column: "5",
        title: "NASA：美国宇航局的地球时刻-气体问题",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502416704466_39_1292.mp4",
      },
      {
        column: "6",
        title: "NASA：美国宇航局的地球时刻-格陵兰冰原",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502416686866_39_198.mp4",
      },
      {
        column: "7",
        title: "NASA：美国宇航局的地球时刻-惯犯祸首",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502416686055_39_1969.mp4",
      },
      {
        column: "8",
        title: "NASA：美国宇航局的地球时刻-我是气溶胶",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502416686487_39_1108.mp4",
      },
      {
        column: "9",
        title: "NASA：美国宇航局的地球时刻-地球使命",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502416685034_39_1141.mp4",
      },
      {
        column: "10",
        title: "NASA：美国宇航局的地球时刻-地球发烧了",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502416685357_39_1286.mp4",
      },
      {
        column: "11",
        title: "NASA：美国宇航局的地球时刻-多云的预报",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502416685670_39_1252.mp4",
      },
      {
        column: "12",
        title: "NASA：美国宇航局的地球时刻-为什么美国宇航局要研究地球？",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502416684715_39_1158.mp4",
      },
    ],
  },
  {
    title: "耶鲁大学：天体物理学之探索和争议",
    desc: "本课程讲述了天文学领域三个有趣而又发展迅速的课题：太阳系外行星，黑洞和暗能量。这些课题将明显提高在未来数年我们对天文学的认识。它探讨的不仅是我们现在所了解的也包括我们所不了解的，以及天文学家是如何探索的。 教授：Charles Bailyn 简介：耶鲁大学天文系本科课程主任 学位：哈佛大学天文学博士 视频来自 http://oyc.yale.edu CC知识共享协议 3.0美国 BY-NC-SA 使用要求：http://oyc.yale.edu/terms#course",
    list: [
      {
        column: "1",
        title: "耶鲁：天体物理学之探索和争议-1介绍（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430705404_39_1582.mp4",
      },
      {
        column: "2",
        title: "耶鲁：天体物理学之探索和争议-2介绍（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430748404_39_1151.mp4",
      },
      {
        column: "3",
        title: "耶鲁：天体物理学之探索和争议-3介绍（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430770273_39_1291.mp4",
      },
      {
        column: "4",
        title: "耶鲁：天体物理学之探索和争议-4行星轨迹（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430945079_39_1475.mp4",
      },
      {
        column: "5",
        title: "耶鲁：天体物理学之探索和争议-5行星轨迹（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430971280_39_1950.mp4",
      },
      {
        column: "6",
        title: "耶鲁：天体物理学之探索和争议-6行星轨迹（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502431027662_39_1266.mp4",
      },
      {
        column: "7",
        title: "耶鲁：天体物理学之探索和争议-10发现系外行星：热木星（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430638736_39_1299.mp4",
      },
      {
        column: "8",
        title: "耶鲁：天体物理学之探索和争议-11发现系外行星：热木星（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430639036_39_1675.mp4",
      },
      {
        column: "9",
        title: "耶鲁：天体物理学之探索和争议-12发现系外行星：热木星（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430639290_39_1607.mp4",
      },
      {
        column: "10",
        title: "耶鲁：天体物理学之探索和争议-13行星凌（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430639583_39_1713.mp4",
      },
      {
        column: "11",
        title: "耶鲁：天体物理学之探索和争议-14行星凌（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430639864_39_1438.mp4",
      },
      {
        column: "12",
        title: "耶鲁：天体物理学之探索和争议-15行星凌（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430640170_39_197.mp4",
      },
      {
        column: "13",
        title:
          "耶鲁：天体物理学之探索和争议-16引力透镜，天体测量学和其他方法（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430640480_39_1296.mp4",
      },
      {
        column: "14",
        title:
          "耶鲁：天体物理学之探索和争议-17引力透镜，天体测量学和其他方法（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430704501_39_1475.mp4",
      },
      {
        column: "15",
        title:
          "耶鲁：天体物理学之探索和争议-18引力透镜，天体测量学和其他方法（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430704802_39_1875.mp4",
      },
      {
        column: "16",
        title: "耶鲁：天体物理学之探索和争议-19直接成像的系外行星（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430705118_39_1733.mp4",
      },
      {
        column: "17",
        title: "耶鲁：天体物理学之探索和争议-20直接成像的系外行星（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430705695_39_1410.mp4",
      },
      {
        column: "18",
        title: "耶鲁：天体物理学之探索和争议-21直接成像的系外行星（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430705981_39_1556.mp4",
      },
      {
        column: "19",
        title: "耶鲁：天体物理学之探索和争议-22介绍黑洞（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430706332_39_1766.mp4",
      },
      {
        column: "20",
        title: "耶鲁：天体物理学之探索和争议-23介绍黑洞（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430726548_39_1621.mp4",
      },
      {
        column: "21",
        title: "耶鲁：天体物理学之探索和争议-24介绍黑洞（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430726852_39_1586.mp4",
      },
      {
        column: "22",
        title: "耶鲁：天体物理学之探索和争议-25狭义相对论和广义相对论1（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430727122_39_1598.mp4",
      },
      {
        column: "23",
        title: "耶鲁：天体物理学之探索和争议-26狭义相对论和广义相对论1（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430727497_39_1460.mp4",
      },
      {
        column: "24",
        title: "耶鲁：天体物理学之探索和争议-27狭义相对论和广义相对论1（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430727760_39_1271.mp4",
      },
      {
        column: "25",
        title: "耶鲁：天体物理学之探索和争议-28试验的相关性（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430728112_39_1820.mp4",
      },
      {
        column: "26",
        title: "耶鲁：天体物理学之探索和争议-29试验的相关性（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430728434_39_1267.mp4",
      },
      {
        column: "27",
        title: "耶鲁：天体物理学之探索和争议-30试验的相关性（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430748698_39_1143.mp4",
      },
      {
        column: "28",
        title: "耶鲁：天体物理学之探索和争议-31狭义相对论和广义相对论2（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430748943_39_1100.mp4",
      },
      {
        column: "29",
        title: "耶鲁：天体物理学之探索和争议-32狭义相对论和广义相对论2（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430749182_39_1873.mp4",
      },
      {
        column: "30",
        title: "耶鲁：天体物理学之探索和争议-33狭义相对论和广义相对论2（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430749416_39_1228.mp4",
      },
      {
        column: "31",
        title: "耶鲁：天体物理学之探索和争议-34恒星质量黑洞1（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430749657_39_1627.mp4",
      },
      {
        column: "32",
        title: "耶鲁：天体物理学之探索和争议-35恒星质量黑洞1（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430749893_39_147.mp4",
      },
      {
        column: "33",
        title: "耶鲁：天体物理学之探索和争议-36恒星质量黑洞1（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430769344_39_1895.mp4",
      },
      {
        column: "34",
        title: "耶鲁：天体物理学之探索和争议-37恒星质量黑洞2（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430769573_39_1186.mp4",
      },
      {
        column: "35",
        title: "耶鲁：天体物理学之探索和争议-38恒星质量黑洞2（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430769804_39_1949.mp4",
      },
      {
        column: "36",
        title: "耶鲁：天体物理学之探索和争议-39恒星质量黑洞2（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430770041_39_1439.mp4",
      },
      {
        column: "37",
        title: "耶鲁：天体物理学之探索和争议-40脉冲星（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430770513_39_1300.mp4",
      },
      {
        column: "38",
        title: "耶鲁：天体物理学之探索和争议-41脉冲星（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430770743_39_1253.mp4",
      },
      {
        column: "39",
        title: "耶鲁：天体物理学之探索和争议-42脉冲星（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430827056_39_1174.mp4",
      },
      {
        column: "40",
        title: "耶鲁：天体物理学之探索和争议-43超大质量黑洞（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430827383_39_1453.mp4",
      },
      {
        column: "41",
        title: "耶鲁：天体物理学之探索和争议-44超大质量黑洞（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430827660_39_1787.mp4",
      },
      {
        column: "42",
        title: "耶鲁：天体物理学之探索和争议-45超大质量黑洞（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430827923_39_1815.mp4",
      },
      {
        column: "43",
        title: "耶鲁：天体物理学之探索和争议-46哈勃定律和宇宙大爆炸1（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430828240_39_1188.mp4",
      },
      {
        column: "44",
        title: "耶鲁：天体物理学之探索和争议-47哈勃定律和宇宙大爆炸1（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430828480_39_1315.mp4",
      },
      {
        column: "45",
        title: "耶鲁：天体物理学之探索和争议-48哈勃定律和宇宙大爆炸1（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430828721_39_1225.mp4",
      },
      {
        column: "46",
        title: "耶鲁：天体物理学之探索和争议-49哈勃定律和宇宙大爆炸2（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430944824_39_1824.mp4",
      },
      {
        column: "47",
        title: "耶鲁：天体物理学之探索和争议-50哈勃定律和宇宙大爆炸2（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430945334_39_1422.mp4",
      },
      {
        column: "48",
        title: "耶鲁：天体物理学之探索和争议-51哈勃定律和宇宙大爆炸2（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430945582_39_1274.mp4",
      },
      {
        column: "49",
        title: "耶鲁：天体物理学之探索和争议-52哈勃定律和宇宙大爆炸3（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430945831_39_1206.mp4",
      },
      {
        column: "50",
        title: "耶鲁：天体物理学之探索和争议-53哈勃定律和宇宙大爆炸3（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430946109_39_1313.mp4",
      },
      {
        column: "51",
        title: "耶鲁：天体物理学之探索和争议-54哈勃定律和宇宙大爆炸3（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430946377_39_1489.mp4",
      },
      {
        column: "52",
        title: "耶鲁：天体物理学之探索和争议-55欧米茄和宇宙的终结（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430969844_39_1276.mp4",
      },
      {
        column: "53",
        title: "耶鲁：天体物理学之探索和争议-56欧米茄和宇宙的终结（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430970127_39_1752.mp4",
      },
      {
        column: "54",
        title: "耶鲁：天体物理学之探索和争议-57欧米茄和宇宙的终结（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430970411_39_1836.mp4",
      },
      {
        column: "55",
        title: "耶鲁：天体物理学之探索和争议-58暗物质（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430970700_39_1175.mp4",
      },
      {
        column: "56",
        title: "耶鲁：天体物理学之探索和争议-59暗物质（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430970965_39_1456.mp4",
      },
      {
        column: "57",
        title: "耶鲁：天体物理学之探索和争议-60暗物质（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502430971526_39_1622.mp4",
      },
      {
        column: "58",
        title: "耶鲁：天体物理学之探索和争议-64超新星（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502431025691_39_1329.mp4",
      },
      {
        column: "59",
        title: "耶鲁：天体物理学之探索和争议-65超新星（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502431025983_39_1384.mp4",
      },
      {
        column: "60",
        title: "耶鲁：天体物理学之探索和争议-66超新星（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502431026435_39_168.mp4",
      },
      {
        column: "61",
        title:
          "耶鲁：天体物理学之探索和争议-67其他方面的限制-宇宙微波背景（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502431026749_39_1376.mp4",
      },
      {
        column: "62",
        title:
          "耶鲁：天体物理学之探索和争议-68其他方面的限制-宇宙微波背景（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502431027072_39_1154.mp4",
      },
      {
        column: "63",
        title:
          "耶鲁：天体物理学之探索和争议-69其他方面的限制-宇宙微波背景（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502431027375_39_1975.mp4",
      },
      {
        column: "64",
        title: "耶鲁：天体物理学之探索和争议-70多元宇宙和万物的理论（上）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502431064386_39_1125.mp4",
      },
      {
        column: "65",
        title: "耶鲁：天体物理学之探索和争议-71多元宇宙和万物的理论（中）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502431064663_39_1619.mp4",
      },
      {
        column: "66",
        title: "耶鲁：天体物理学之探索和争议-72多元宇宙和万物的理论（下）",
        url: "http://vskd.bj.bcebos.com//video/2017/8/11/20178111502431064932_39_1654.mp4",
      },
    ],
  },
];
</script>
<style lang="scss" scoped>
ul,
ol {
  list-style: none outside none;
}

ul,
ol,
li,
dl,
dt,
dd {
  padding: 0;
  margin: 0;
}

.video_channel {
  height: 120px;
  margin-bottom: 40px;
  background: #fff;
  box-shadow: 0 4px 20px 0 rgba(74, 118, 227, 0.23);

  .vc_concent {
    display: flex;
    flex-wrap: wrap;
    padding: 24px 0 0;
    @include wrap;

    .vc_item {
      position: relative;
      width: 220px;
      margin-bottom: 10px;
      font-size: 22px;
      font-weight: 600;
      line-height: 30px;
      color: #353535;
      a {
        font-family: PingFangSC-Semibold, sans-serif;
        color: #353535;
        text-decoration: none;
      }
      a:hover {
        color: #1f91f4;
      }
    }

    .vc_item:nth-child(1)::before,
    .vc_item:nth-child(2)::before,
    .vc_item:nth-child(3)::before,
    .vc_item:nth-child(4)::before,
    .vc_item:nth-child(5)::before {
      @include channelSize;
    }

    .vc_item:nth-child(6n + 6) {
      width: 100px;
    }
  }
}

.video_details {
  position: relative;
  @include wrap;
  //video {
  //  margin-bottom: 50px;
  //  vertical-align: middle;
  //}

  .v_player {
    width: 906px;
    height: 510px;
    margin-bottom: 50px;
    vertical-align: middle;

    ::v-deep .vjs-album-control {
      order: 10;
      width: 42px;
      background: url("~@/assets/xuanji.png") no-repeat center;
    }
  }

  .video_album {
    position: absolute;
    top: 0;
    right: 294px;
    width: 200px;
    height: 510px;
    background: #000;
    opacity: 0.6;
    //ul{
    .album_bar {
      display: inline-block;
      width: 200px;
      height: 28px;
      margin-top: 18px;
      font-size: 14px;
      color: #fff;

      .album_item {
        float: left;
        margin-left: 18px;
      }

      .cancel {
        float: right;
        margin-right: 18px;
      }

      .cancel:hover {
        color: #7082f3;
      }

      //border: 2px solid red;
    }

    .album_num {
      width: 200px;
      height: 422px;
      margin-top: 10px;
      overflow: auto;
      //-ms-overflow-style: none;
      //overflow: -moz-scrollbars-none;
      //scrollbar-width: none;
      * {
        padding: 0;
        margin: 0;
        list-style: none;
      }

      li {
        float: left;
        width: 32px;
        height: 32px;
        margin-bottom: 10px;
        margin-left: 12px;

        p {
          //display: inline-block;
          width: 28px;
          height: 14px;
          padding: 9px 2px;
          font-size: 14px;
          color: #fff;
          text-align: center;
          text-decoration: none;
        }

        //border: 2px solid red;
      }

      .active {
        background-color: #619aff;
      }

      li:nth-child(4n + 1) {
        margin-left: 18px;
      }

      li:hover {
        background: #7082f3;
      }
    }

    //.album_num::-webkit-scrollbar {
    //  width: 0 !important;
    //-ms-overflow-style: none;
    //overflow: -moz-scrollbars-none;
    //}

    //}
  }

  //.album_active{
  //
  //}

  .vd_right {
    position: absolute;
    top: 0;
    right: 0;
    width: 276px;
    height: 510px;

    .vd_header {
      margin-bottom: 30px;
      @include clearfix;

      .vdh_author {
        position: relative;
        float: left;
        width: 70px;
        height: 70px;
        overflow: hidden;
        border-radius: 50%;

        img {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: auto;
          transform: translate(-50%, -50%);
        }
      }

      .vdh_title {
        float: left;
        width: 196px;
        margin-left: 10px;

        p {
          margin: 0 0 10px;
          font-size: 18px;
          font-weight: bold;
          color: #333;
        }

        button {
          width: 50px;
          height: 24px;
          padding: 0;
          font-size: 14px;
          color: #fff;
          background: #1f91f4;
          border: none;
          border-radius: 4px;
        }
      }
    }

    .vd_title {
      width: 100%;
      margin-bottom: 10px;

      p {
        font-size: 18px;
        font-weight: 600;
        color: #333;

        button {
          display: inline-block;
          width: 40px;
          height: 18px;
          font-size: 12px;
          color: #fff;
          background: #5381e8;
          border: none;
          border-radius: 4px;
        }
      }
    }

    .vd_text {
      width: 256px;
      height: 180px;
      padding: 10px;
      margin-bottom: 20px;
      overflow-x: hidden;
      overflow-y: auto;
      font-size: 14px;
      color: #666;

      img {
        width: 100%;
        height: auto;
      }
    }

    /* 滚动条 */
    .vd_text::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    .vd_text::-webkit-scrollbar-thumb {
      background-color: #cbcbcb;
      border-radius: 3px;
    }

    .vd_text::-webkit-scrollbar-track {
      background-color: rgba(255, 255, 255, 0.1);
      border-radius: 3px;
    }

    .vd_play_comments {
      @include clearfix;
      @include fontSize(14px, 400, #999, 18px);

      .vdc_play {
        float: left;
      }

      .vdc_comments {
        float: right;
      }
    }

    .vd_release {
      margin: 12px 0;
      @include fontSize(14px, 400, #999, 18px);
    }

    .vd_copyright {
      @include fontSize(14px, 400, #999, 18px);
    }

    .share_info {
      margin-top: 8px;

      .share_sub {
        float: left;
        height: 26px;
        margin-top: 4px;
        vertical-align: middle;
        @include fontSize(14px, 400, #999, 18px);
      }

      ::v-deep .social-share-icon {
        width: 16px;
        height: 16px;
        font-size: 10px;
        line-height: 16px;
      }
    }
  }

  .recommend {
    .title {
      margin: 0 0 16px;
      @include fontSize(24px, bold, #333, 30px);
    }

    .content {
      @include clearfix;

      li {
        float: left;
        width: 270px;
        height: 220px;
        margin-right: 40px;

        a {
          text-decoration: none;
        }

        .cul_img {
          //position: relative;
          width: 270px;
          height: 151px;
          overflow: hidden;
          background-color: #d8d8d8;
          border-radius: 4px;

          img {
            width: 100%;
            //position: absolute;
            //top: 50%;
            //left: 50%;
            //z-index: 3;
            height: 100%;
            //transform: translate(-50%, -50%);
          }

          .time {
            width: 100%;
            height: 18px;
            //position: absolute;
            //bottom: 0;
            //left: 0;
            //z-index: 10;
            //box-sizing: border-box;
            margin-top: -20px;
            //padding: 10px 12px;
            font-size: 14px;
            font-weight: 500;
            line-height: 12px;
            color: #fff;
            //color: red;

            span {
              display: inline-block;
              width: 40%;
              height: 100%;
            }

            span:nth-child(1) {
              margin-left: 5%;
              text-align: left;
            }

            span:nth-child(2) {
              margin-left: 10%;
              text-align: right;
            }
          }
        }

        .cul_title1 {
          margin: 10px 0;
          @include fontSize(16px, 500, #333);
          @include textoverflow;
        }

        .cul_title2 {
          @include fontSize(14px, 400, #999);
        }
      }
    }
  }

  .vd_cmt {
    margin: 20px 0 60px;

    .comment {
      .title {
        position: relative;
        padding-left: 18px;
        @include fontSize(24px, 500, #333);
      }

      .title::after {
        position: absolute;
        top: 6px;
        left: 0;
        display: block;
        width: 6px;
        height: 22px;
        content: "";
        background-color: #0064c9;
      }

      .item {
        margin: 15px 0 30px;

        .item_label {
          @include clearfix;

          .portrait {
            position: relative;
            float: left;
            width: 42px;
            height: 42px;

            .p_img {
              width: 100%;
              height: 100%;
              overflow: hidden;
              border-radius: 50%;

              img {
                width: 100%;
                height: auto;
                vertical-align: middle;
              }
            }

            .p_img::after {
              position: absolute;
              right: 0;
              bottom: 0;
              display: block;
              width: 20px;
              height: 20px;
              line-height: 20px;
              color: #fff;
              text-align: center;
              content: "证";
              background-color: #fd7b43;
              border-radius: 50%;
            }
          }

          .commentator {
            float: left;
            margin-left: 16px;
            @include fontSize(18px, 500, #333, 42px);
          }

          .grade {
            position: relative;
            float: left;
            margin-left: 20px;
            @include fontSize(18px, 500, #fd7b43, 42px);
          }

          .grade::before {
            position: absolute;
            top: 19px;
            left: -10px;
            display: inline-block;
            width: 4px;
            height: 4px;
            margin-right: 4px;
            content: "";
            background-color: #fd7b43;
            border-radius: 50%;
          }
        }

        .item_text {
          margin-left: 58px;
          @include fontSize(16px, 400, #333, 22px);
        }

        .item_date {
          margin: 15px 0 0 58px;
          @include fontSize(14px, 400, #999, 20px);
        }
      }
    }

    .act_footer {
      box-sizing: border-box;
      width: 100%;
      height: 46px;
      padding-left: 20px;
      margin-top: 40px;
      line-height: 46px;
      text-align: center;
      background: #f4f4f4;
      border-radius: 23px;
      @include clearfix;

      button {
        height: 24px;
        padding: 0 8px;
        margin: 0 2px;
        color: #fff;
        background: linear-gradient(180deg, #ee275f 0%, #fc7544 100%);
        background-color: #2491ea;
        background-image: -moz-linear-gradient(
          180deg,
          #65b5fc 0%,
          #2491ea 100%
        );
        background-image: -o-linear-gradient(180deg, #65b5fc 0%, #2491ea 100%);
        background-image: -webkit-gradient(180deg, #65b5fc 0%, #2491ea 100%);
        background-image: -webkit-linear-gradient(
          180deg,
          #65b5fc 0%,
          #2491ea 100%
        );
        background-image: -ms-linear-gradient(180deg, #65b5fc 0%, #2491ea 100%);
        background-image: linear-gradient(180deg, #65b5fc 0%, #2491ea 100%);
        border: none;
        border-radius: 14px;
        outline: none;
      }
    }
  }
}
</style>
